import moment from 'moment';
import Multiselect from 'multiselect-react-dropdown';
import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';
import { Button, OverlayTrigger, Popover, Tooltip, Modal, Form, ProgressBar } from 'react-bootstrap';
import { BiMessageAltDetail, BiShareAlt, BiTrash, BiUpload, BiMessage, BiSearch, BiFile, BiSpreadsheet, BiShow, BiDownload } from 'react-icons/bi';
import { BsCalculator, BsInfoCircle, BsQuestionCircle, BsFileEarmarkText, BsFileEarmarkPdf, BsFileEarmarkWord, BsFileEarmarkExcel, BsFileEarmarkPpt, BsFileEarmarkZip } from "react-icons/bs";
import { AiOutlineFileText, AiOutlineFilePdf, AiOutlineFileWord, AiOutlineFileExcel, AiOutlineFilePpt, AiOutlineFileZip, AiOutlineFileImage, AiOutlineFileUnknown } from "react-icons/ai";
import { FaClockRotateLeft } from "react-icons/fa6";
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { FormSubmissionContext, GlbFormContext, LoaderContext, CompanyContext, SidebarContext } from '../../App';
import NumericAnswerField from '../../components/Answer/NumericAnswerField';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import ConfirmDialog from '../../core/utilities/ConfirmPopup';
import FormFooter from '../../components/Form/FormFooter';
import FormHeader from '../../components/Form/FormHeader';
import ResizablePanel from '../../components/layout/ResizablePanel';
import { usePanelResize } from '../../hooks/usePanelResize';
import { COMPLETED_STATUS, ExternalDependencyType, FormStatus, QuestionType } from '../../core/constants/common';
import useBaseForm from '../../core/hooks/useBaseForm';
import { useCallbackPrompt } from '../../core/hooks/useCallbackPrompt';
import FileService from '../../core/services/FileService';
import FormService from '../../core/services/FormService';
import FormEditService from '../../core/services/FromEditService';
import Utils from '../../core/utilities/Utils';
import { excludeGridQuestionResponses, flattenFormFields, getInputTypeForFieldType } from '../../core/utilities/gridQuestionUtils';
import { getVisibleQuestionNumber } from '../../core/utilities/questionNumbering';
import ExternalDependencyPopup from '../ExternalDependency/ExternalDependencyPopup';
import '../FormSubmit/FormSubmit.scss';
import SubmittedResponseView from '../FormSubmit/SubmittedResponseView';
import FormSubmitTreeNavigation from '../FormSubmit/FormSubmitTreeNavigation';
import ShareFormModal from "../ShareFormModal/ShareFormModal";
import GridQuestionView from '../../components/GridQuestionView/GridQuestionView';
import GridTable from '../../components/RadioGridView/GridTable';
import DataTable from '../../components/TableView/DataTable';
import FilePreview from '../../components/FilePreview/FilePreview';
import ocr_icon from '../../images/ocr_icon.png';
import '../../design-system/index.scss';
import '../../components/ui/ui.scss';
import '../../components/layout/builder-shell.scss';
import '../../components/layout/preview-shell.scss';


let SUBMISSION_ID;
const AUTO_SAVE_ENABLED = false;

const FormSimplePageView = () => {
  const currentURL = window.location.href;
  const isFormInReview = currentURL.includes('/open-form/review');
  const isOpenForm = isFormInReview || window.location.href.includes('/open-form/submit');
  const { paramObj } = useParams();
  const { token } = useParams();
  const { langId } = useParams();
  const { id } = useParams();
  const [formStatus, setFormStatus] = useState('');
  const [showShareModal, setShowShareModal] = useState(false);
  const { setLoaderState } = useContext(LoaderContext)
  const { glbForm, setGlbForm } = useContext(GlbFormContext);
  const { companyId } = useContext(CompanyContext);
  const isLoggedin = localStorage.getItem('accessToken') ? true : false;
  const [totalQuestionCount, setTotalQuestionCount] = useState(0);
  const [answeredQuestionCount, setAnsweredQuestionCount] = useState(0);
  const [unitsOfMeasure, setUnitsOfMeasure] = useState([]);
  const [sectionSubmissions, setSectionSubmissions] = useState([]);
  const [chosenLocationInSection, setChosenLocationInSection] = useState(0);
  const [hasSubmForCurSection, setHasSubmForCurSection] = useState(false);
  const [locations, setLocations] = useState([]);
  const [submittedData, setSubmittedData] = useState(null);
  const nextButtonRef = useRef(null);
  const submitButtonRef = useRef(null);
  const [isDirty, setDirty] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(isDirty);
  const [showUnsavedWarning, setShowUnsavedWarning] = useState(false);
  const { setFormSubmissionData } = useContext(FormSubmissionContext);
  const [extDepLinkData, setExtDepLinkData] = useState('');
  const [showComment, setShowComment] = useState({});
  const [fileUploadEnabled, setFileUploadEnabled] = useState({});
  const [fileSelected, setFileSelected] = useState(false);
  const {
    formatPreviewResponseForApplyingLogics,
    initializeResponseForField,
    multiSelectArraySet,
    calculateTotalQuestionCount,
    populateHistoricResponses,
    applyLogicDefinitonsOnFieldResponse,
    findField,
    initializeFormQuestions,
    initializeHistResponseArrayFor,
    initializeFormQuestionsForHistResponse,
    isCommentInvalid,
    isFileInvalid,
    checkValidationError,
    updateOptionSelectionValidation,
    getOptionValidationMessage,
    shouldDisableOption,
    handleFilePreview,
    handleFilePreviewClose,
    formdata, setFormData,
    responseData, setResponseData,
    histResponseData, setHistResponseData,
    activeSectionData, setActiveSectionData,
    validationerrors, setValidationErrors,
    previewFileData, setPreviewFileData,
    previewFileContent, setPreviewFileContent,
    previewFileType, setPreviewFileType,
    showFilePreviewModal, setShowFilePreviewModal,
    ocrData, setOcrData
  } = useBaseForm();
  const [isSinglePageView, setIsSinglePageView] = useState(true);
  const { widths, setSidebarWidth } = usePanelResize();
  // Same source of truth the old FormSidebar used, so the app-wide sidebar
  // toggle button (App.js) keeps working for this page's sidebar too.
  const { sidebarDisplay: sidebarOpen = true } = useContext(SidebarContext) || {};
  const [visiblePopovers, setVisiblePopovers] = useState({});
  const fileInputRef = useRef();
  const fileMandatoryInputRef = useRef();
  const [isForcedRedirection, setIsForcedRedirection] = useState(false);
  const [showSubmitModals, setShowSubmitModals] = useState({
    submitConfirmationModal: false,
    navigateToResponseModal: false
  })
  const [dataFile, setDataFile] = useState(null);
  const [confirmDeleteFile, setConfirmDeleteFile] = useState({ show: false, itemIndex: null, fileId: null, fileIndex: null, fileName: null });
  const [ocrProgress, setOcrProgress] = useState({
    isProcessing: false,
    progress: 0,
    status: '',
    currentStep: '',
    jobId: null
  });
  const [fileNameShow, setFileNameShow] = useState('');
  let decodedData = null;
  let decodedObj = {};

  if (!token || token === "undefined") {
    decodedData = Utils.decodeBase64(paramObj);
    decodedObj = JSON.parse(decodedData);
    if (decodedObj.sId) {
      SUBMISSION_ID = decodedObj.sId;
    }
  }

  useEffect(() => {
    getFormDetails(langId);
  }, [langId]);

  useEffect(() => {
    if (companyId || glbForm?.company) {
      loadUnitsOfMeasure();
    }
  }, [companyId, glbForm?.company]);

  useEffect(() => {
    if (!isDirty && isForcedRedirection) {
      const url = Utils.getFormattedFormBuilderExitURL();
      if (!url) return;

      window.location.href = url;
    }
  }, [isDirty, isForcedRedirection]);

  // Cleanup modal states on unmount
  useEffect(() => {
    return () => {
      setOcrData({
        modalDisplay: false,
        item: null,
        data: null,
        value: null,
        index: null
      });
      setShowFilePreviewModal(false);
      setPreviewFileData(null);
      setPreviewFileContent(null);
      setPreviewFileType(null);
      // Reset OCR progress on unmount
      setOcrProgress({
        isProcessing: false,
        progress: 0,
        status: '',
        currentStep: '',
        jobId: null
      });
    };
  }, []);

  const getFormDetails = (langId) => {
    setLoaderState({ display: true, type: 'TEXTUAL' });
    let key = decodedObj?.key ? decodedObj?.key : token;
    let req;
    if (isFormInReview) {
      req = FormService.getSkeletonForReview(key);
    } else {
      req = FormEditService.getSubmitFormDetails(key, langId);
    }
    req?.then((response) => {
      setLoaderState({ display: false });
      const data = formatPreviewResponseForApplyingLogics(response.data);
      setFormData(data);
      setGlbForm(data);
      let initArray = [];
      data?.fields?.forEach((field) => {
        const obj = {
          formField: {
            id: field.id
          }
        }
        initializeResponseForField(field, obj);
        initArray.push(obj);
      })
      initializeFormQuestions(initArray, data?.sections);
      setHistResponseData({});
      const histResArray = {};
      initializeHistResponseArrayFor(data?.fields, data, histResArray);
      initializeFormQuestionsForHistResponse(histResArray, data?.sections, data);
      if (SUBMISSION_ID || isOpenForm) {
        getSubmittedData({
          arrSend: initArray,
          langId: langId,
          sectionId: 0,
          form: data,
          histResData: histResArray
        });
      } else {
        setFormStatus('IN_PROGRESS');
        setResponseData(initArray);
        setHistResponseData(histResArray);
      }
      refreshTotalQuestionCount(data);
    }).catch((error) => {
      setLoaderState({ display: false });
    });
  };

  const getSubmittedData = ({ arrSend, langId, sectionId, form = null, histResData }) => {
    setLoaderState({ display: true });
    let key = decodedObj?.key ? decodedObj?.key : token;
    let sId = SUBMISSION_ID ?? '';
    let req;
    if (isFormInReview) {
      req = FormService.getSubmittedDataForReview(key);
    } else {
      req = FormEditService.getSubmittedFormData(key, langId, sId);
    }
    req?.then((response) => {
      setLoaderState({ display: false });
      let responseArr = response.data.responses;
      if (isOpenForm) {
        SUBMISSION_ID = response.data.submissionId;
      }
      setSubmittedData(response.data);
      setFormStatus(response.data.status);
      setFormSubmissionData({ status: response.data.status, formReviewRequest: response.data.formReviewRequest });
      for (let i = 0; i < arrSend.length; i++) {
        for (let j = 0; j < responseArr.length; j++) {
          if (arrSend[i].formField.id === responseArr[j].formField.id) {

            if (responseArr[j].fieldType === 'MULTIPLE_CHOICE' || responseArr[j].fieldType === 'MULTI_SELECT_DROP_DOWN') {
              const formField = findField(arrSend[i].formField.id, form);
              let dataReturn = multiSelectArraySet(formField, responseArr[j].responseOptions);
              arrSend[i]['responseOptions'] = dataReturn.arrayId;
              if (responseArr[j].fieldType === 'MULTI_SELECT_DROP_DOWN') {
                arrSend[i]['responseOptionsShow'] = dataReturn.filterArray;
              }
            }
            if (responseArr[j].fieldType === 'DROP_DOWN' || responseArr[j].fieldType === 'RADIO') {
              arrSend[i]['responseOptions'] = responseArr[j].responseOptions;
            } else if (responseArr[j].fieldType === 'SINGLE_TEXTBOX' || responseArr[j].fieldType === 'TEXT_BOX') {
              arrSend[i]['textResponse'] = responseArr[j].textResponse;
            } else if (responseArr[j].fieldType === 'DATE_TIME_BOX') {
              arrSend[i]['dateResponse'] = responseArr[j].dateResponse;
            } else if (responseArr[j].fieldType === 'DATE_RANGE') {
              arrSend[i]['dateResponse'] = responseArr[j].dateResponse;
              arrSend[i]['toDateResponse'] = responseArr[j].toDateResponse;
            } else if (responseArr[j].fieldType === 'FILE_UPLOAD') {
              arrSend[i]['files'] = responseArr[j].files;
            } else if (responseArr[j].fieldType === 'NUMERIC_VALUE') {
              arrSend[i]['numericResponse'] = responseArr[j].numericResponse ?? '';
              if (responseArr[j].uom) {
                arrSend[i]['uom'] = responseArr[j].uom;
              }
            } else if (responseArr[j].fieldType === 'RADIO_GRID') {
              arrSend[i]['gridResponses'] = responseArr[j].gridResponses;
            } else if (responseArr[j].fieldType === 'TABLE') {
              arrSend[i]['tableRowResponses'] = responseArr[j].tableRowResponses;
            }
            arrSend[i]['remarkResponse'] = responseArr[j].remarkResponse;
            arrSend[i]['otherResponse'] = responseArr[j].otherResponse;
            arrSend[i]['files'] = responseArr[j].files;
          }
        }
      };
      populateHistoricResponses(response.data.linkedSubmissions, histResData);
      const hasSubmissions = hasSubmissionForTheCurrentSection({
        currentSectionId: sectionId,
        submissions: response.data.sectionSubmissions,
        form: form ?? formdata
      });
      setHasSubmForCurSection(hasSubmissions);
      // If there are submissions for the current section,
      // then do not populate data for save.
      if (hasSubmissions) {
        setResponseData([]);
        // Populate locations and set active location if there is no active location.
        if (chosenLocationInSection > 0) return;

        populateAndSetActiveLocation({
          sectionId: sectionId,
          submissions: response.data.sectionSubmissions,
          form: form ?? formdata
        });
      } else {
        setResponseData(arrSend);
        setHistResponseData(histResData);
      }
      const fDataClone = JSON.parse(JSON.stringify(form ?? formdata));
      for (let i = 0; i < arrSend.length; i++) {
        const field = findField(arrSend[i].formField.id, fDataClone);
        applyLogicDefinitonsOnFieldResponse({
          field: field,
          index: i,
          responseArray: arrSend,
          histResponseArray: histResData,
          formSkeleton: fDataClone
        });
      }
      setFormData(fDataClone);
      refreshTotalQuestionCount(fDataClone);
      calculateAnsweredQuestionCount(responseArr, fDataClone);
    })
      .catch((error) => {
        setLoaderState({ display: false });
        toast.dismiss();
        const errorRes = error.response;
        if (errorRes?.status === 400) {
          if (!token) {
            toast.error(errorRes?.data?.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            setFormStatus('IN_PROGRESS');
            setResponseData(arrSend);
          }
        }
      });
  };

  const onSelectDeSelectML = (selectedList, selectedItem, index, item) => {
    let mulObjArr = [];
    let arr = [...responseData];
    for (let i = 0; i < selectedList.length; i++) {
      mulObjArr.push({
        id: parseInt(selectedList[i].id),
        name: item.options?.find(o => o.id === +selectedList[i].id)?.name
      });
    }
    arr[index]['responseOptions'] = mulObjArr;
    arr[index]['responseOptionsShow'] = selectedList;
    // Validate option selection for MULTIPLE_CHOICE if applicable
    if (item.type === QuestionType.MULTIPLE_CHOICE) {
      const selectedCount = mulObjArr?.length || 0;
      updateOptionSelectionValidation(item, selectedCount);
    }
    setResponseData(arr);
    const fDataClone = JSON.parse(JSON.stringify(formdata));
    applyLogicDefinitonsOnFieldResponse({
      field: item,
      index: index,
      responseArray: arr,
      histResponseArray: JSON.parse(JSON.stringify(histResponseData)),
      formSkeleton: fDataClone
    });
    setFormData(fDataClone);
  }

  const submitRequestConstructor = (index, item, isUnit = false, activateAutoSave = false) => (e) => {
    let isOtherOption = false;
    if (item.type === 'RADIO' || item.type === 'DROP_DOWN' || item.type === 'MULTIPLE_CHOICE') {
      isOtherOption = e.target.value === 'other';
    }
    let sendObj = null;
    let arr = [...responseData];

    if (item.type === 'MULTI_SELECT_DROP_DOWN') {
      let mulObjArr = [];
      for (let i = 0; i < item.selectedList.length; i++) {
        const objId = {
          id: parseInt(item.id)
        }
        mulObjArr.push(objId);
      }
      arr[index]['responseOptions'] = mulObjArr;
    } else {
      if (e.target.value != null && e.target.value != undefined && e.target.value !== '') {
        sendObj = {
          id: isOtherOption ? e.target.value : parseInt(e.target.value) || -1
        };
      }

      if (item.type === 'SINGLE_TEXTBOX' || item.type === 'TEXT_BOX') {
        arr[index]['textResponse'] = e.target.value;
      } else if (item.type === 'RADIO' || item.type === 'DROP_DOWN') {
        if (sendObj != null) {
          sendObj = {
            ...sendObj,
            name: item.options?.find(o => o.id === (+e.target.value || -1))?.name
          };
          arr[index]['responseOptions'] = [sendObj];
        }
      } else if (item.type === 'RADIO_GRID') {
        let gridResponses = arr[index]['gridResponses'] || [];

        item.gridConfig.rows.forEach(row => {
          row.cellOptions.forEach(option => {
            if (option.id === +e.target.value) {
              const existingResponse = gridResponses.find(response => response.rowId === row.id);
              const existingId = existingResponse ? existingResponse.id : null;
              gridResponses = gridResponses.filter(response => response.rowId !== row.id);
              gridResponses.push({
                id: existingId,
                rowId: option.rowId,
                columnId: option.columnId,
                cellOption: {
                  id: option.id
                }
              });
            }
          });
        });

        arr[index]['gridResponses'] = gridResponses;
      } else if (item.type === 'MULTI_SELECT_DROP_DOWN' || item.type === 'MULTIPLE_CHOICE') {
        let indexFilter = arr[index]['responseOptions'].findIndex(x => x.id == e.target.value);
        if (indexFilter !== -1) {
          arr[index]['responseOptions'].splice(indexFilter, 1);
        } else {
          if (sendObj != null) {
            sendObj = {
              ...sendObj,
              name: item.options?.find(o => o.id === (+e.target.value || -1))?.name
            };
            arr[index]['responseOptions'].push(sendObj);
          }
        }
        // Validate option selection for MULTIPLE_CHOICE
        if (item.type === QuestionType.MULTIPLE_CHOICE) {
          const selectedCount = arr[index]['responseOptions']?.length || 0;
          updateOptionSelectionValidation(item, selectedCount);
        }
      } else if (item.type === 'DATE_TIME_BOX') {
        arr[index]['dateResponse'] = e.target.value;
      } else if (item.type === 'DATE_RANGE') {
        if (e.target.id === "dateResponse") {
          arr[index]['dateResponse'] = e.target.value;
        }
        else {
          arr[index]['toDateResponse'] = e.target.value;
        }

      } else if (item.type === 'FILE_UPLOAD') {
        arr[index]['files'] = [e.target.value];
      } else if (item.type === 'NUMERIC_VALUE') {
        if (isUnit) {
          arr[index]['uom'] = e.target.value;
        } else {
          arr[index]['numericResponse'] = e.target.value === '' ? '' : +e.target.value;
        }
      }

      if (item.allowFileUpload) {
        arr[index]['fileType'] = [
          ...(arr[index]['files'] || []),
          {

            fileName: e.target.value
          }
        ];
      }

    }
    setResponseData(arr);

    setDirty(true);
    if (!isOtherOption) {
      const fDataClone = JSON.parse(JSON.stringify(formdata));
      applyLogicDefinitonsOnFieldResponse({
        field: item,
        index: index,
        responseArray: arr,
        histResponseArray: JSON.parse(JSON.stringify(histResponseData)),
        formSkeleton: fDataClone
      });
      setFormData(fDataClone);
      refreshTotalQuestionCount(fDataClone);
      calculateAnsweredQuestionCount(arr, fDataClone);
    }
    if (!AUTO_SAVE_ENABLED || !activateAutoSave) return;

    saveFormData(index, arr, true);
  }
  const submitRequestConstructors = (index, item, isUnit = false, activateAutoSave = false) => (e) => {
    let arr = [...responseData]
    if (item.allowRemark) {
      arr[index]['remarkResponse'] = e.target.value;
      setResponseData(arr);
    }
    if (arr[index]['remarkResponse'].length) {
      setDirty(true);
    }
  }

  const saveForm = (isFinalSave) => {
    const body = {
      responses: excludeGridQuestionResponses(responseData, formdata)
    }
    if (SUBMISSION_ID) {
      body['submissionId'] = SUBMISSION_ID;
    }
    if (formdata.historicalDataSupported) {
      const linkedSubmissions = [];
      const subMonth = formdata?.assessment.period ? formdata?.assessment.period?.split('-')[1] : '01';
      const subDay = formdata?.assessment.period ? formdata?.assessment.period?.split('-')[2] : '01';
      Object.keys(histResponseData)?.forEach(year => {
        linkedSubmissions.push({
          period: `${year}-${subMonth}-${subDay}`,
          responses: histResponseData[year].responses,
          submissionId: histResponseData[year].submissionId ?? null
        });
      });
      body.linkedSubmissions = linkedSubmissions;
    }
    setLoaderState({ display: true });
    let key = decodedObj?.key ? decodedObj?.key : token;
    FormEditService.submitForm(key, body, isFinalSave, isLoggedin)
      .then((response) => {

        if (isFinalSave) {

          toast.success("Your response has been submitted successfully", {
            position: toast.POSITION.TOP_RIGHT,
          });
          if (isLoggedin) {
            setDirty(false);
            setIsForcedRedirection(true);
          } else {
            FormEditService.getSubmittedFormData(
              decodedObj?.key ? decodedObj?.key : token,
              langId,
              response.data.submissionId)
              .then((res) => {
                setSubmittedData(res.data);
                calculateAnsweredQuestionCount(res.data.responses, formdata);
              }).catch(err => { });
          }
          setShowSubmitModals({ submitConfirmationModal: false, navigateToResponseModal: true });
        } else {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          SUBMISSION_ID = response.data.submissionId;
        }
        setDirty(false);
        setShowUnsavedWarning(false);
        setLoaderState({ display: false });
        enableActionButtons();
      })
      .catch((error) => {
        handleFormDataSaveError(error);
        enableActionButtons();
        if (isFinalSave) {
          setShowSubmitModals({ submitConfirmationModal: false, navigateToResponseModal: false });
        }
      });
  }

  const isCheckboxChecked = (options, id) => {
    if (!options || options?.length === 0) return false;

    return options.findIndex(x => +x.id === +id) >= 0;
  };

  const handleFileSelect = (index, event) => {
    const fileUploaded = event.target.files[0];
    if (fileUploaded.size <= 1024 * 1024 * 2) {
      // console.log('fileUploaded', fileUploaded);
      setDataFile(fileUploaded);
      const formData = new FormData();
      formData.append("document", fileUploaded);
      let arr = [...responseData];
      let key = decodedObj?.key ? decodedObj?.key : token;
      setLoaderState({ display: true });
      FileService.uploadfile(formData, key)
        .then((response) => {
          setLoaderState({ display: false });
          arr[index]['files'] = [{
            id: response.data.id,
            fileName: event.target.files[0].name
          }];
          setResponseData(arr);
          event.target.value = null;
        })
        .catch((error) => {
          setLoaderState({ display: false });
          event.target.value = null;
        })
        .finally(() => {

        });
    } else {
      fileInputRef.current.value = null;
      setLoaderState({ display: false });
      toast.warning('Upload files less than 2MB', {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const handleFileSelects = (index, event) => {
    event.target.files.length && setDirty(true);
    const filesUploaded = Array.from(event.target.files);
    let arr = [...responseData];
    let key = decodedObj?.key ? decodedObj?.key : token;
    filesUploaded.forEach((file, i) => {
      if (file.size <= 1024 * 1024 * 2) {
        setDataFile(file);
        const formData = new FormData();
        formData.append("document", file);
        setLoaderState({ display: true });
        FileService.uploadfile(formData, key)
          .then((response) => {
            setLoaderState({ display: false });

            // Append the new file to the existing files array
            arr[index]['files'] = [
              ...(arr[index]['files'] || []), // Preserve existing files if any
              {
                id: response.data.id,
                fileName: file.name
              }
            ];
            setResponseData(arr);
            event.target.value = null;
          })
          .catch((error) => {
            setLoaderState({ display: false });
            event.target.value = null;
          });
      } else {
        fileMandatoryInputRef.current.value = null;
        setLoaderState({ display: false });
        toast.warning('Upload files less than 2MB', {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    });
  };


  const handleDownloadFile = (id) => {
    let key = decodedObj?.key ? decodedObj?.key : token;
    FileService.downloadFile({
      token: key,
      fileId: id,
      submissionId: isLoggedin ? submittedData.id : '',
      isReview: isFormInReview
    }).then((response) => {
      let fetchDataModified = `data:${response.data.contentType};base64,${response.data.content}`;
      let link = document.createElement("a");
      link.href = fetchDataModified;
      link.download = response.data.fileName;
      link.click();
    })
      .catch((error) => { });
  };

  const removeFiles = (itemIndex, fileIndex) => {
    let arr = [...responseData];
    if (arr[itemIndex] && arr[itemIndex].files) {
      arr[itemIndex].files = arr[itemIndex].files.filter((_, index) => index !== fileIndex);
    }
    setResponseData(arr);
    return arr;
  };

  const handleRemoveFile = (itemIndex, fileId, fileIndex) => {
    let key = decodedObj?.key ? decodedObj?.key : token;
    setLoaderState({ display: true });
    FileService.deleteFile(key, fileId)
      .then(() => {
        setLoaderState({ display: false });
        const arr = removeFiles(itemIndex, fileIndex);
        saveFormData(itemIndex, arr);
      })
      .catch((error) => {
        setLoaderState({ display: false });
        toast.error(error.response?.data?.message || 'Failed to delete file', {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const requestRemoveFile = (itemIndex, fileId, fileIndex, fileName) => {
    setConfirmDeleteFile({ show: true, itemIndex, fileId, fileIndex, fileName });
  };

  const getRemarkField = (field, index) => {
    let responseOptions;
    let isMandatory = false;
    let showRemark = false;
    if (field.allowRemark) {
      if (field.type === 'RADIO'
        || field.type === 'MULTIPLE_CHOICE'
        || field.type === 'DROP_DOWN') {
        responseOptions = responseData[index]?.responseOptions;

      } else if (field.type === 'MULTI_SELECT_DROP_DOWN') {
        responseOptions = responseData[index]?.responseOptionsShow;
      }
      for (let i = 0; i < responseOptions?.length; i++) {
        const rOption = responseOptions[i];
        const twinOption = field.options?.find(opt => +opt.id === +rOption.id);
        if (twinOption?.showRemarks) {
          showRemark = true;
          isMandatory = twinOption.remarksMandatory;
          break;
        }
      }
    }
    return showRemark && <>{
      <div>
        <label className="form-check-label" htmlFor="remarktitle">{field.remarkLabel}</label>
        <div className="mb-2">
          <input className='form-control'
            disabled={formStatus === COMPLETED_STATUS}
            type="text"
            required={isMandatory}
            value={responseData[index]?.remarkResponse}
            onChange={(e) => onRemarkChange(e.target.value, field, index)} />
        </div>
      </div>
    }</>
  };

  const getOtherField = (field, index) => {
    let isMandatory = false;
    let showOthers = false;
    if (field.allowOtherOption) {
      let responseOptions;
      if (field.type === 'RADIO'
        || field.type === 'MULTIPLE_CHOICE'
        || field.type === 'DROP_DOWN') {
        responseOptions = responseData[index]?.responseOptions;
      } else if (field.type === 'MULTI_SELECT_DROP_DOWN') {
        responseOptions = responseData[index]?.responseOptionsShow;
      }
      for (let i = 0; i < responseOptions?.length; i++) {
        const rOption = responseOptions[i];
        const twinOption = field.options?.find(opt => opt.id === rOption.id);
        if (twinOption?.showOthers) {
          showOthers = true;
          isMandatory = field.otherFieldValidation?.mandatory;
          break;
        }
      }
    }
    return showOthers && <>{
      <div>
        {/* <label className="form-check-label" htmlFor="otherfieldtitle">{field.otherTextLabel}</label> */}
        <div className="mb-2">
          <input className='form-control'
            disabled={formStatus === COMPLETED_STATUS}
            type="text"
            required={isMandatory}
            value={responseData[index].otherResponse}
            onChange={(e) => onOtherFieldTextChange(e.target.value, field, index)}
            placeholder={field.otherTextLabel} />
        </div>
      </div>
    }</>
  };

  const onRemarkChange = (value, field, index) => {
    let data = [...responseData];
    if (data[index]) {
      data[index]['remarkResponse'] = value;
      setResponseData(data);
    }
  };

  const onOtherFieldTextChange = (value, field, index) => {
    let data = [...responseData];
    if (data[index]) {
      data[index]['otherResponse'] = value;
      setResponseData(data);
    }
  };

  const shareSection = () => {
    setShowShareModal(true);
  }
  const callbackShareModal = (obj) => {
    setShowShareModal(false);
  }

  const calculateAnsweredQuestionCount = (responseArray, formSkeleton) => {
    let answeredCount = 0;
    for (let j = 0; j < responseArray.length; j++) {
      const response = responseArray[j];
      const formField = findField(response.formField?.id, formSkeleton);
      // If the responded formfield is hidden in the formskeleton then skip
      if (formField && formField.hide_alt) continue;

      if ((formField.type === 'MULTIPLE_CHOICE'
        || formField.type === 'MULTI_SELECT_DROP_DOWN')
        && response.responseOptions?.length > 0) {
        answeredCount++;
      } else if ((formField.type === 'DROP_DOWN'
        || formField.type === 'RADIO')
        && response.responseOptions?.length > 0) {
        answeredCount++;
      } else if ((formField.type === 'SINGLE_TEXTBOX'
        || formField.type === 'TEXT_BOX')
        && response.textResponse !== null
        && response.textResponse !== '') {
        answeredCount++;
      } else if (formField.type === 'DATE_TIME_BOX'
        && response.dateResponse !== null
        && response.dateResponse !== '') {
        answeredCount++;
      } else if (formField.type === 'DATE_RANGE'
        && response.toDateResponse !== null
        && response.toDateResponse !== '') {
        answeredCount++;
      } else if (formField.type === 'FILE_UPLOAD'
        && response.files?.length > 0) {
        answeredCount++;
      } else if (formField.type === 'NUMERIC_VALUE'
        && response.numericResponse !== ''
        && response.numericResponse !== null) {
        answeredCount++;
      } else if (formField.type === 'RADIO_GRID'
        && response.gridResponses?.length > 0) {
        answeredCount++;
      } else if (formField.type === 'TABLE'
        && response.tableRowResponses?.length > 0) {
        answeredCount++;
      }
    }
    setAnsweredQuestionCount(answeredCount);
  };

  const loadUnitsOfMeasure = () => {
    FormService.getUnitsOfMeasure(companyId ?? glbForm?.company?.id)
      .then(res => {
        if (!res.data || res.data?.length === 0) return;

        const inputList = [];
        res.data?.forEach(element => {
          inputList.push({
            value: element.inputUnit,
            label: element.inputUnitName,
          });
        });
        const uniqueInputArray = Array.from(new Set(inputList.map(obj => obj.value))).map(
          value => inputList.find(obj => obj.value === value)
        );
        uniqueInputArray.sort((a, b) => a.value.localeCompare(b.value));
        setUnitsOfMeasure(uniqueInputArray);
      })
      .catch((error) => {
      });
  };

  const handleOCRModalClose = useCallback(() => {
    setOcrData({
      modalDisplay: false,
      item: null,
      data: null,
      value: null,
      index: null
    });
    // Reset OCR progress when modal is closed
    setOcrProgress({
      isProcessing: false,
      progress: 0,
      status: '',
      currentStep: '',
      jobId: null
    });
  }, [setOcrData]);

  const pollOCRProgress = useCallback((jobId, onComplete) => {
    const pollInterval = setInterval(async () => {
      try {
        const response = await FormService.getOCRProgress(jobId);
        const progressData = response.data;

        setOcrProgress({
          isProcessing: progressData.status === 'in-progress',
          progress: progressData.progress || 0,
          status: progressData.status,
          currentStep: progressData.current_step || '',
          jobId: jobId
        });

        if (progressData.status === 'completed') {
          clearInterval(pollInterval);
          setOcrProgress({
            isProcessing: false,
            progress: 100,
            status: 'completed',
            currentStep: 'Processing completed',
            jobId: null
          });
          onComplete(progressData.result);
        } else if (progressData.status === 'failed' || progressData.error) {
          clearInterval(pollInterval);
          setOcrProgress({
            isProcessing: false,
            progress: 0,
            status: 'failed',
            currentStep: 'Processing failed',
            jobId: null
          });
          toast.error('OCR processing failed', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        clearInterval(pollInterval);
        setOcrProgress({
          isProcessing: false,
          progress: 0,
          status: 'failed',
          currentStep: 'Error checking progress',
          jobId: null
        });
        toast.error('Failed to check OCR progress', {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }, 4000); // Poll every 2 seconds

    // Cleanup function
    return () => clearInterval(pollInterval);
  }, [setOcrProgress]);

  const getOCRData = async ({ item, index, fileId, token, submissionId, isFormInReview, applyOCRData = true, fileName }) => {
    setFileNameShow(fileName);
    setLoaderState({ display: true });
    const fileResponse = await FileService.downloadFile({
      token: token,
      fileId: fileId,
      submissionId: submissionId,
      isReview: isFormInReview
    });
    if (fileResponse.data?.metadata) {
      const metadata = JSON.parse(fileResponse.data.metadata);
      let ocrD = {
        data: metadata,
        item: item,
        modalDisplay: true,
      };
      if (metadata.suggestedData) {
        if (metadata.suggestedData.type === 'multiple' && metadata.suggestedData.values?.length > 0) {
          ocrD = { ...ocrD, value: metadata.suggestedData.values[0] };
        } else if (metadata.suggestedData.value !== undefined) {
          ocrD = { ...ocrD, value: metadata.suggestedData };
        }
      } else {
        ocrD = { ...ocrD, value: { value: '', unit: '' } };
      }
      setOcrData(ocrD);
      setLoaderState({ display: false });
    } else {
      extractOCRDataAndApply({ fileResponse: fileResponse.data, question: item, index: index, applyOCRData: applyOCRData, token: token });
    }
  };

  const extractOCRDataAndApply = ({ fileResponse, question, index, applyOCRData, token }) => {
    const fileData = new FormData();
    fileData.append('questionLabel', question.name || '');
    fileData.append('questionId', question.id);
    fileData.append('unitId', 0);
    fileData.append('unitLabel', question.relevantUoms ? question.relevantUoms.join(',') : '');
    fileData.append('file', Utils.base64ToFile(fileResponse.content, fileResponse.fileName, fileResponse.contentType));

    FormService.getOCRData(fileData).then((res) => {
      setLoaderState({ display: false });

      // Check if response has job_id (new structure) or direct result (old structure)
      if (res.data.job_id) {
        // New job-based structure
        setOcrProgress({
          isProcessing: true,
          progress: 0,
          status: 'in-progress',
          currentStep: res.data.message || 'OCR processing started',
          jobId: res.data.job_id
        });

        // Show progress modal
        let ocrD = {
          data: {
            questionLabel: question.name,
            extractedContent: { content: 'Processing...', content_type: 'processing' },
            suggestedData: null
          },
          item: question,
          index: index,
          modalDisplay: true,
          value: { value: '', unit: '' }
        };
        setOcrData(ocrD);

        // Start polling for progress
        pollOCRProgress(res.data.job_id, (result) => {
          // Update metadata with the result
          FileService.updateMetadata(token, fileResponse.id, JSON.stringify(result)).then(metaRes => { }).catch(err => { });

          // Always show the modal with results, regardless of single or multiple suggestions
          let ocrD = {
            data: result,
            item: question,
            index: index,
            modalDisplay: true,
          };

          // Set default selection if there's suggested data
          if (result.suggestedData) {
            if (result.suggestedData.type === 'multiple' && result.suggestedData.values?.length > 0) {
              ocrD = { ...ocrD, value: result.suggestedData.values[0] };
            } else if (result.suggestedData.value !== undefined) {
              ocrD = { ...ocrD, value: result.suggestedData };
            }
          } else {
            // If no suggested data, set a default empty selection to enable the Apply button
            ocrD = { ...ocrD, value: { value: '', unit: '' } };
          }
          setOcrData(ocrD);
        });
      } else {
        // Old direct response structure
        FileService.updateMetadata(token, fileResponse.id, JSON.stringify(res.data)).then(metaRes => { }).catch(err => { });

        // Always show the modal with results, regardless of single or multiple suggestions
        let ocrD = {
          data: res.data,
          item: question,
          index: index,
          modalDisplay: true,
        };
        // Set default selection if there's suggested data
        if (res.data.suggestedData) {
          if (res.data.suggestedData.type === 'multiple' && res.data.suggestedData.values?.length > 0) {
            ocrD = { ...ocrD, value: res.data.suggestedData.values[0] };
          } else if (res.data.suggestedData.value !== undefined) {
            ocrD = { ...ocrD, value: res.data.suggestedData };
          }
        } else {
          // If no suggested data, set a default empty selection to enable the Apply button
          ocrD = { ...ocrD, value: { value: '', unit: '' } };
        }
        setOcrData(ocrD);
      }
    }).catch((err) => {
      setLoaderState({ display: false });
      toast.error('Failed to extract data from file', {
        position: toast.POSITION.TOP_RIGHT,
      });
    });
  };

  const applyOCRValueToField = (ocrValue, item, index) => {
    let arr = [...responseData];

    // Set the numeric value
    if (ocrValue.value !== undefined) {
      arr[index]['numericResponse'] = ocrValue.value;
    }

    // Match unit by label and set the correct unit value
    if (ocrValue.unit) {
      let matchedUnit = '';

      // First check if the current item has relevantUoms
      if (item.relevantUoms && item.relevantUoms.length > 0) {
        // Try to find exact match in relevantUoms (case-insensitive)
        const exactMatch = item.relevantUoms.find(uom =>
          uom.toLowerCase() === ocrValue.unit.toLowerCase()
        );

        if (exactMatch) {
          matchedUnit = exactMatch;
        }
      } else {
        // If no relevantUoms, check in unitsOfMeasure
        const unitMatch = unitsOfMeasure.find(unit =>
          unit.label.toLowerCase() === ocrValue.unit.toLowerCase() ||
          unit.value.toLowerCase() === ocrValue.unit.toLowerCase()
        );

        if (unitMatch) {
          matchedUnit = unitMatch.value;
        }
      }

      // Set the matched unit or empty string (which will show "Select" option)
      arr[index]['uom'] = matchedUnit;
    }

    setResponseData(arr);
    setDirty(true);

    // Apply logic definitions
    const fDataClone = JSON.parse(JSON.stringify(formdata));
    applyLogicDefinitonsOnFieldResponse({
      field: item,
      index: index,
      responseArray: arr,
      histResponseArray: JSON.parse(JSON.stringify(histResponseData)),
      formSkeleton: fDataClone
    });
    setFormData(fDataClone);

    // Show success message with details
    const unitMessage = arr[index]['uom'] ?
      `Value: ${ocrValue.value}, Unit: ${arr[index]['uom']}` :
      `Value: ${ocrValue.value}, Unit: No match found (set to Select)`;

    toast.success(`Data read and applied successfully.`, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const handleOCRApply = useCallback(() => {
    if (!ocrData.value || ocrData.index === null) return;

    applyOCRValueToField(ocrData.value, ocrData.item, ocrData.index);
    handleOCRModalClose();
  }, [ocrData.value, ocrData.index, ocrData.item, handleOCRModalClose, applyOCRValueToField]);

  // Add file type detection utility function
  const getFileTypeInfo = (file) => {
    // if (!file) return { type: 'Unknown', icon: <AiOutlineFileUnknown size={24} /> };

    // const fileName = file.name || '';
    const fileExtension = fileNameShow.split('.').pop()?.toLowerCase();

    // Define file type mappings with React Icons
    const fileTypes = {
      // Images
      'jpg': { type: 'JPEG Image', icon: <AiOutlineFileImage size={24} color="#e74c3c" /> },
      'jpeg': { type: 'JPEG Image', icon: <AiOutlineFileImage size={24} color="#e74c3c" /> },
      'png': { type: 'PNG Image', icon: <AiOutlineFileImage size={24} color="#3498db" /> },
      'gif': { type: 'GIF Image', icon: <AiOutlineFileImage size={24} color="#9b59b6" /> },
      'bmp': { type: 'BMP Image', icon: <AiOutlineFileImage size={24} color="#34495e" /> },
      'tiff': { type: 'TIFF Image', icon: <AiOutlineFileImage size={24} color="#2c3e50" /> },
      'webp': { type: 'WebP Image', icon: <AiOutlineFileImage size={24} color="#27ae60" /> },

      // Documents
      'pdf': { type: 'PDF Document', icon: <AiOutlineFilePdf size={24} color="#e74c3c" /> },
      'doc': { type: 'Word Document', icon: <AiOutlineFileWord size={24} color="#3498db" /> },
      'docx': { type: 'Word Document', icon: <AiOutlineFileWord size={24} color="#3498db" /> },
      'xls': { type: 'Excel Spreadsheet', icon: <AiOutlineFileExcel size={24} color="#27ae60" /> },
      'xlsx': { type: 'Excel Spreadsheet', icon: <AiOutlineFileExcel size={24} color="#27ae60" /> },
      'ppt': { type: 'PowerPoint Presentation', icon: <AiOutlineFilePpt size={24} color="#e67e22" /> },
      'pptx': { type: 'PowerPoint Presentation', icon: <AiOutlineFilePpt size={24} color="#e67e22" /> },

      // Text files
      'txt': { type: 'Text File', icon: <AiOutlineFileText size={24} color="#34495e" /> },
      'rtf': { type: 'Rich Text File', icon: <AiOutlineFileText size={24} color="#34495e" /> },

      // Archives
      'zip': { type: 'ZIP Archive', icon: <AiOutlineFileZip size={24} color="#f39c12" /> },
      'rar': { type: 'RAR Archive', icon: <AiOutlineFileZip size={24} color="#f39c12" /> },
      '7z': { type: '7-Zip Archive', icon: <AiOutlineFileZip size={24} color="#f39c12" /> },
      'tar': { type: 'TAR Archive', icon: <AiOutlineFileZip size={24} color="#f39c12" /> },
      'gz': { type: 'GZIP Archive', icon: <AiOutlineFileZip size={24} color="#f39c12" /> }
    };

    return fileTypes[fileExtension] || { type: 'Unknown File', icon: <AiOutlineFileUnknown size={24} color="#95a5a6" /> };
  };

  const renderOCRModal = useCallback(() => {
    if (!ocrData.modalDisplay || !ocrData.data) return null;

    // Get file type information
    const fileTypeInfo = getFileTypeInfo(dataFile);

    const beautifyExtractedContent = (content) => {
      // Enhanced content processing for better display
      const processedContent = content
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .trim();

      // Split into lines and process each line
      const lines = processedContent.split('\n');

      return lines
        .filter(line => line.trim().length > 0)
        .map((line, index) => {
          const trimmedLine = line.trim();

          // Detect different types of content for better styling
          const isHeader = /^[A-Z][A-Z\s]+$/.test(trimmedLine) && trimmedLine.length < 50;
          const isNumber = /^\d+\.?\s*/.test(trimmedLine);
          const isTableRow = /\t|\s{3,}/.test(trimmedLine);
          const isKeyValue = /[:：]\s*/.test(trimmedLine);
          const isBold = /^\*.*\*$/.test(trimmedLine) || /^_.*_$/.test(trimmedLine);

          let lineContent = trimmedLine;
          let lineStyle = {};
          let lineClass = 'ocr-line';

          // Apply different styles based on content type
          if (isHeader) {
            lineClass += ' ocr-header';
            lineStyle = {
              fontWeight: 'bold',
              fontSize: '16px',
              color: '#2c3e50',
              borderBottom: '2px solid #009efb',
              paddingBottom: '4px',
              marginBottom: '8px'
            };
          } else if (isNumber) {
            lineClass += ' ocr-numbered';
            lineStyle = {
              fontWeight: '500',
              color: '#34495e',
              paddingLeft: '8px',
              borderLeft: '3px solid #009efb'
            };
          } else if (isTableRow) {
            lineClass += ' ocr-table-row';
            lineStyle = {
              fontFamily: 'monospace',
              fontSize: '13px',
              backgroundColor: '#f8f9fa',
              padding: '4px 8px',
              borderRadius: '4px',
              border: '1px solid #e9ecef'
            };
          } else if (isKeyValue) {
            lineClass += ' ocr-key-value';
            const parts = lineContent.split(/[:：]\s*/);
            if (parts.length >= 2) {
              lineContent = (
                <>
                  <span style={{ fontWeight: 'bold', color: '#2c3e50' }}>
                    {parts[0]}:
                  </span>
                  <span style={{ marginLeft: '8px', color: '#34495e' }}>
                    {parts.slice(1).join(': ')}
                  </span>
                </>
              );
            }
            lineStyle = {
              padding: '4px 0',
              borderBottom: '1px solid #ecf0f1'
            };
          } else if (isBold) {
            lineClass += ' ocr-bold';
            lineContent = lineContent.replace(/^[*_](.*)[*_]$/, '$1');
            lineStyle = {
              fontWeight: 'bold',
              color: '#2c3e50'
            };
          } else {
            lineStyle = {
              color: '#34495e',
              lineHeight: '1.5'
            };
          }

          return (
            <div
              key={index}
              className={lineClass}
              style={{
                marginBottom: '6px',
                padding: '2px 0',
                ...lineStyle
              }}
            >
              {lineContent}
            </div>
          );
        });
    };

    const handleOptionClick = (option) => {
      setOcrData({ ...ocrData, value: option })
    };

    const handleMouseEnter = (e) => {
      e.target.style.borderColor = '#009efb';
      e.target.style.backgroundColor = '#f8f9fa';
      e.target.style.transform = 'translateY(-1px)';
      e.target.style.boxShadow = '0 4px 8px rgba(0, 158, 251, 0.15)';
    };

    const handleMouseLeave = (e) => {
      e.target.style.borderColor = '#dee2e6';
      e.target.style.backgroundColor = 'white';
      e.target.style.transform = 'translateY(0)';
      e.target.style.boxShadow = 'none';
    };

    const renderSuggestedDataOptions = () => {
      if (!ocrData.data.suggestedData) return <div className="mt-3">No suggested data</div>;

      if (ocrData.data.suggestedData.type === 'multiple' && ocrData.data.suggestedData.values) {
        return (
          <div className="">
            <div className="d-flex align-items-center mb-3">
              <div className="me-2" style={{
                width: '4px',
                height: '20px',
                backgroundColor: '#009efb',
                borderRadius: '2px'
              }}></div>
              <h6 className="m-0" style={{
                color: '#2c3e50',
                fontWeight: '600',
                fontSize: '1rem'
              }}>
                Suggested Values from AI
              </h6>
            </div>
            {ocrData.data.suggestedData.values.map((option, index) => {
              const isSelected = ocrData.value === option;
              return (
                <div
                  key={index}
                  className={`ocr-option-card mb-3 p-3 border rounded cursor-pointer ${isSelected ? 'border-primary' : 'border-light'}`}
                  onClick={() => handleOptionClick(option)}
                  style={{
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    cursor: 'pointer',
                    position: 'relative',
                    borderWidth: isSelected ? '2px' : '1px',
                    backgroundColor: isSelected ? '#f8f9fa' : 'white',
                    borderColor: isSelected ? '#009efb' : '#dee2e6'
                  }}
                  onMouseEnter={!isSelected ? handleMouseEnter : undefined}
                  onMouseLeave={!isSelected ? handleMouseLeave : undefined}
                >
                  <div className="d-flex align-items-center">
                    <div
                      className={`me-3 rounded-circle d-flex align-items-center justify-content-center ${isSelected ? 'bg-primary text-white' : 'bg-light border'}`}
                      style={{
                        width: '24px',
                        height: '24px',
                        minWidth: '24px',
                        borderColor: isSelected ? '#009efb' : '#dee2e6',
                        backgroundColor: isSelected ? '#009efb' : '#f8f9fa'
                      }}
                    >
                      {isSelected && (
                        <span style={{ fontSize: '12px', fontWeight: 'bold' }}>✓</span>
                      )}
                    </div>
                    <div className="flex-grow-1">
                      <div className="fw-bold" style={{ color: '#2c3e50' }}>
                        {option.label}: {option.value} {option.unit}
                      </div>
                      {option.context && (
                        <small className="text-muted" style={{ fontSize: '0.85rem' }}>
                          {option.context}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      } else if (ocrData.data.suggestedData.value !== undefined) {
        const isSelected = ocrData.value === ocrData.data.suggestedData;
        return (
          <div className="mt-3">
            <div className="d-flex align-items-center mb-3">
              <div className="me-2" style={{
                width: '4px',
                height: '20px',
                backgroundColor: '#009efb',
                borderRadius: '2px'
              }}></div>
              <h6 className="m-0" style={{
                color: '#2c3e50',
                fontWeight: '600',
                fontSize: '1rem'
              }}>
                Suggested Value from AI
              </h6>
            </div>
            <div
              className={`ocr-option-card p-3 border rounded cursor-pointer ${isSelected ? 'border-primary' : 'border-light'}`}
              onClick={() => handleOptionClick(ocrData.data.suggestedData)}
              style={{
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: 'pointer',
                position: 'relative',
                borderWidth: isSelected ? '2px' : '1px',
                backgroundColor: isSelected ? '#f8f9fa' : 'white',
                borderColor: isSelected ? '#009efb' : '#dee2e6'
              }}
              onMouseEnter={!isSelected ? handleMouseEnter : undefined}
              onMouseLeave={!isSelected ? handleMouseLeave : undefined}
            >
              <div className="d-flex align-items-center">
                <div
                  className={`me-3 rounded-circle d-flex align-items-center justify-content-center ${isSelected ? 'bg-primary text-white' : 'bg-light border'}`}
                  style={{
                    width: '24px',
                    height: '24px',
                    minWidth: '24px',
                    borderColor: isSelected ? '#009efb' : '#dee2e6',
                    backgroundColor: isSelected ? '#009efb' : '#f8f9fa'
                  }}
                >
                  {isSelected && (
                    <span style={{ fontSize: '12px', fontWeight: 'bold' }}>✓</span>
                  )}
                </div>
                <div className="flex-grow-1">
                  <div className="fw-bold" style={{ color: '#2c3e50' }}>
                    {ocrData.data.suggestedData.value} {ocrData.data.suggestedData.unit || ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
      return null;
    };

    // Calculate modal height based on screen size
    const calculateModalHeight = () => {
      const screenHeight = window.innerHeight;
      const headerHeight = 60; // Reduced header height
      const footerHeight = 70; // Slightly reduced footer height
      const padding = 40; // Reduced padding for more content space

      // Use 90% of available screen height, with minimum and maximum constraints
      const availableHeight = Math.min(Math.max(screenHeight * 0.90, 700), 1000);
      return availableHeight - headerHeight - footerHeight - padding;
    };

    const modalBodyHeight = calculateModalHeight();

    return (
      <Modal show={ocrData.modalDisplay} onHide={handleOCRModalClose} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{
            color: '#2c3e50',
            fontWeight: '700',
            fontSize: '1.1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
          }}>
            {/* <span>Data </span> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{
          padding: '1.5rem',
          height: `${modalBodyHeight}px`,
          overflowY: 'auto'
        }}>
          <div className="row g-4">
            <div className="col-md-12">
              <div className="d-flex align-items-center mb-3">
                <div className="me-2" style={{
                  width: '4px',
                  height: '24px',
                  background: 'linear-gradient(135deg, #009efb 0%, #0d6efd 100%)',
                  borderRadius: '2px'
                }}></div>
                <h6 className="m-0" style={{
                  color: '#2c3e50',
                  fontWeight: '600',
                  fontSize: '1.1rem',
                  letterSpacing: '0.3px'
                }}>
                  {ocrProgress.isProcessing ?
                    <span>Extracting contents for: <span style={{ color: '#009efb' }}>{ocrData.data.questionLabel}</span></span> :
                    <span>Extracted contents for: <span style={{ color: '#009efb' }}>{ocrData.data.questionLabel}</span></span>}
                </h6>
              </div>
            </div>
            <div className="row col-md-12">
              <div className={ocrProgress.isProcessing ? "col-md-12" : "col-md-6"}>
                <div>


                  {/* OCR Progress Bar */}
                  {ocrProgress.isProcessing && (
                    <div className="mb-4 p-4 border rounded" style={{
                      background: 'linear-gradient(135deg, #f8f9ff 0%, #e7f1ff 100%)',
                      borderColor: '#0d6efd',
                      borderWidth: '2px',
                      boxShadow: '0 4px 16px rgba(13, 110, 253, 0.15)',
                      borderRadius: '12px',
                      animation: 'slideInDown 0.5s ease-out'
                    }}>
                      <div className="d-flex align-items-center mb-3">
                        <div style={{
                          marginRight: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px',
                          borderRadius: '8px',
                          backgroundColor: 'rgba(13, 110, 253, 0.1)',
                          animation: 'pulse 2s infinite'
                        }}>
                          <i className="fas fa-spinner fa-spin" style={{
                            color: '#0d6efd',
                            fontSize: '1.3rem',
                            animation: 'spin 1s linear infinite'
                          }}></i>
                        </div>
                        <div>
                          <div style={{
                            fontSize: '1.1rem',
                            fontWeight: '600',
                            color: '#0d6efd',
                            marginBottom: '4px',
                            animation: 'fadeInUp 0.6s ease-out'
                          }}>
                            Processing OCR Data from {fileNameShow}
                            <br></br>
                            <span style={{ fontSize: '12px' }}>
                              Please wait while we extract and analyze the document
                            </span>
                          </div>

                        </div>
                      </div>
                      <div className="mb-2">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <small style={{ color: '#0d6efd', fontWeight: '600', fontSize: '0.9rem' }}>Progress</small>
                          <small style={{ color: '#0d6efd', fontWeight: '700', fontSize: '1rem' }}>{ocrProgress.progress}%</small>
                        </div>
                        <div className="progress" style={{
                          height: '12px',
                          borderRadius: '6px',
                          backgroundColor: 'rgba(13, 110, 253, 0.1)',
                          overflow: 'hidden',
                          boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                              width: `${ocrProgress.progress}%`,
                              background: 'linear-gradient(90deg, #0d6efd 0%, #0b5ed7 50%, #0a58ca 100%)',
                              borderRadius: '6px',
                              transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
                              position: 'relative',
                              overflow: 'hidden'
                            }}
                            aria-valuenow={ocrProgress.progress}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%)',
                              animation: 'shimmer 2s infinite',
                              transform: 'translateX(-100%)'
                            }}></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {!ocrProgress.isProcessing && <div
                  className="border rounded p-4"
                  style={{
                    backgroundColor: '#ffffff',
                    fontSize: '14px',
                    border: '2px solid #e9ecef',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05), 0 4px 12px rgba(0, 158, 251, 0.1)',
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
                  }}
                >
                  <div style={{
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    lineHeight: '1.6'
                  }}>
                    {/* {ocrProgress.isProcessing ? (
                    <div className="text-center py-4">
                      <div className="mb-3">
                        <i className="fas fa-spinner fa-spin" style={{ fontSize: '2rem', color: '#ffc107' }}></i>
                      </div>
                      <div style={{ color: '#856404', fontSize: '1.1rem', fontWeight: '500' }}>
                        Processing file content...
                      </div>
                      <div style={{ color: '#856404', fontSize: '0.9rem', marginTop: '8px' }}>
                        Please wait while we extract and analyze the document
                      </div>
                    </div>
                  ) : (
                    beautifyExtractedContent(ocrData.data.extractedContent.content)
                  )} */}
                    {(beautifyExtractedContent(ocrData.data.extractedContent.content))}
                  </div>
                </div>}
              </div>
              {!ocrProgress.isProcessing && <div className="col-md-6">
                <div style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '12px',
                  padding: '1.5rem',
                  border: '1px solid #e9ecef',
                  boxShadow: '0 2px 8px rgba(0, 158, 251, 0.1)'
                }}>
                  {/* {ocrProgress.isProcessing ? (
                  <div className="text-center py-4">
                    <div className="mb-3">
                      <i className="fas fa-cogs fa-spin" style={{ fontSize: '2rem', color: '#009efb' }}></i>
                    </div>
                    <div style={{ color: '#2c3e50', fontSize: '1.1rem', fontWeight: '500' }}>
                      Analyzing Content...
                    </div>
                    <div style={{ color: '#6c757d', fontSize: '0.9rem', marginTop: '8px' }}>
                      AI is processing the extracted text to find relevant values
                    </div>
                  </div>
                ) : (
                  renderSuggestedDataOptions()
                )} */}
                  {!ocrProgress.isProcessing && (renderSuggestedDataOptions())}
                </div>
              </div>}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
          width: '100%'
        }}>
          <Button
            variant="outline-secondary"
            onClick={handleOCRModalClose}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#6c757d';
              e.target.style.color = 'white';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6c757d';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleOCRApply}
            disabled={!ocrData.value || ocrProgress.isProcessing}
            onMouseEnter={(e) => {
              if (ocrData.value && !ocrProgress.isProcessing) {
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 4px 12px rgba(0, 158, 251, 0.4)';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = ocrProgress.isProcessing ? 'none' : '0 2px 8px rgba(0, 158, 251, 0.3)';
            }}
          >
            {ocrProgress.isProcessing ? (
              <>
                <i className="fas fa-spinner fa-spin me-2"></i>
                Processing...
              </>
            ) : (
              <>
                <i className="fas fa-check me-2"></i>
                Apply
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }, [ocrData.modalDisplay, ocrData.data, ocrData.value, handleOCRModalClose, handleOCRApply, dataFile, ocrProgress, setOcrData]);

  const onTableRowsChange = (index, rows) => {
    let arr = [...responseData];
    arr[index]['tableRowResponses'] = rows;
    setResponseData(arr);
    setDirty(true);
    const fDataClone = JSON.parse(JSON.stringify(formdata));
    setFormData(fDataClone);
    refreshTotalQuestionCount(fDataClone);
    calculateAnsweredQuestionCount(arr, fDataClone);
  };

  const renderOptionHelpText = (opt) => {
    if (!opt.helpText) return null;
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Popover id={`popover-help-${opt.id}`} className="p-2">
            <div className="p-1">{opt.helpText}</div>
          </Popover>
        }>
        <span className="ms-2 cursor-pointer">
          <BsQuestionCircle />
        </span>
      </OverlayTrigger>
    );
  };

  // A GRID question never owns an answer itself — each cell is 1:1 linked to
  // another field on the form, and the cell's input just reads/writes that
  // linked field's own responseData entry via the same submitRequestConstructor
  // used everywhere else, so answers are captured under the linked field's id.
  const buildGridAnswerContext = () => {
    const allFields = flattenFormFields(formdata);
    return {
      readOnly: false,
      getDisplayValue: (linkedFieldId) => {
        const linkedField = allFields.find((f) => f.id === linkedFieldId);
        const entry = responseData.find((r) => r.formField.id === linkedFieldId);
        if (!linkedField || !entry) return '';
        if (linkedField.type === QuestionType.NUMERIC_VALUE) return entry.numericResponse ?? '';
        return entry.textResponse ?? '';
      },
      getInputType: (linkedFieldId) => getInputTypeForFieldType(allFields.find((f) => f.id === linkedFieldId)?.type),
      getChangeHandler: (linkedFieldId) => {
        const linkedField = allFields.find((f) => f.id === linkedFieldId);
        const linkedIndex = responseData.findIndex((r) => r.formField.id === linkedFieldId);
        if (!linkedField || linkedIndex === -1) return undefined;
        return submitRequestConstructor(linkedIndex, linkedField, false, true);
      },
      renderExtra: (linkedFieldId) => {
        const linkedField = allFields.find((f) => f.id === linkedFieldId);
        const linkedIndex = responseData.findIndex((r) => r.formField.id === linkedFieldId);
        if (!linkedField || linkedIndex === -1
          || linkedField.type !== QuestionType.NUMERIC_VALUE || !linkedField.uomRequired) return null;
        const relevantUoms = linkedField.relevantUoms;
        return (
          <select
            className="form-select"
            value={responseData[linkedIndex]?.uom ?? ''}
            onChange={submitRequestConstructor(linkedIndex, linkedField, true, true)}
          >
            <option value="">Select</option>
            {relevantUoms?.length > 0
              ? [...relevantUoms].sort((a, b) => a.localeCompare(b)).map((u) => (
                <option key={u} value={u}>
                  {unitsOfMeasure?.length > 0 ? unitsOfMeasure.find((unit) => unit?.value === u)?.label : u}
                </option>
              ))
              : unitsOfMeasure?.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
          </select>
        );
      },
    };
  };

  const renderQuestion = (item, qIndex, disableField = false, fieldValue = null, questionNumber = qIndex + 1) => {
    let index = responseData.findIndex((s) => s?.formField?.id === item.id);
    return (
      <div className={`PS_inner_01 03 questionField-${index}`} key={`questionField-${index}`}>
        <div className='PS_inner_Qus_ViewCard02'>
          <div className='PSS_Qus_ViewCard02'>
            <div className="PSinner_Qus_View_box02">
              <div className="d-flex">
                <h6 className='me-1'>
                  {questionNumber}.
                </h6>
                <div>
                  <h6>
                    {item.name}
                    {!item.optional && <span className="text-danger h5 m-0" style={{ lineHeight: '1px' }}> *</span>}
                    {
                      item.fieldHelpText &&

                      <OverlayTrigger
                        trigger="click"
                        rootClose
                        placement="auto"
                        overlay={popoverClickRootClose(item)}
                        onToggle={() => toggleHelpTextPopover(item.id)}
                      >
                        <span className='mx-2 cursor' onClick={() => toggleHelpTextPopover(item.id)}>
                          <BsQuestionCircle />
                        </span>
                      </OverlayTrigger>

                    }
                  </h6>
                </div>


              </div>
            </div>
            <div className='PSinner_Option_View_box02'>
              <div className='PSinner_Option_View_box02In'>
                {item.type === 'RADIO' &&
                  <div>
                    {item.options.length > 0 && item.options.map((opt) => (
                      <div className="form-check" key={opt.id}>
                        <input className={`form-check-input ${checkValidationError(item.id) && !(
                          fieldValue
                            ? fieldValue.responseOptions[0]?.id === opt.id
                            : responseData[index]?.responseOptions[0]?.id === opt.id
                        )
                          ? 'border-danger'
                          : ''
                          }`}
                          type="radio"
                          disabled={formStatus === COMPLETED_STATUS || disableField}
                          name={item.name}
                          id={opt.id}
                          value={opt.id}
                          checked={
                            fieldValue
                              ? fieldValue.responseOptions[0]?.id === opt.id
                              : responseData[index]?.responseOptions[0]?.id === opt.id
                          }
                          onChange={submitRequestConstructor(index, item, false, true)} />
                        <label className="form-check-label" htmlFor={opt.id} >
                          {opt.name}
                          {renderOptionHelpText(opt)}
                        </label>
                      </div>
                    ))}
                  </div>
                }

                {
                  item.type === 'RADIO_GRID' &&
                  <GridTable
                    type='SUBMIT'
                    content={item}
                    responseData={responseData.filter(data => data.gridResponses)}
                    handleOptionsChange={(e) => submitRequestConstructor(index, item, false, true)(e)}
                  />
                }
                {
                  item.type === QuestionType.TABLE &&
                  <DataTable
                    type='SUBMIT'
                    content={item}
                    responseData={responseData[index]}
                    disabled={formStatus === COMPLETED_STATUS || disableField}
                    onRowsChange={(rows) => onTableRowsChange(index, rows)}
                  />
                }
                {
                  item.type === QuestionType.GRID &&
                  <GridQuestionView
                    content={item}
                    answerContext={buildGridAnswerContext()}
                  />
                }
                {item.type === 'MULTI_SELECT_DROP_DOWN' && <div>
                  {/* <select className='form-select w-auto' multiple onChange={submitRequestConstructor(index, item)}>
                    {item.options.length > 0 && item.options.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.name}
                      </option>
                    ))}
                  </select> */}
                  <Multiselect
                    disable={formStatus === COMPLETED_STATUS || disableField}
                    options={(item.options || []).map((opt) => (opt.showOthers ? { ...opt, name: opt.name || 'Other' } : opt))} // Options to display in the dropdown
                    selectedValues={fieldValue
                      ? fieldValue.responseOptionsShow
                      : responseData[index]?.responseOptionsShow
                    } // Preselected value to persist in dropdown
                    onSelect={(selectedList, selectedItem) => {
                      onSelectDeSelectML(selectedList, selectedItem, index, item)
                    }} // Function will trigger on select event
                    onRemove={(selectedList, selectedItem) => {
                      onSelectDeSelectML(selectedList, selectedItem, index, item)
                    }} // Function will trigger on remove event
                    displayValue="name" // Property name to display in the dropdown options
                  />
                </div>
                }

                {item.type === 'MULTIPLE_CHOICE' && <div>
                  {item.options.length > 0 && item.options.map((opt) => {
                    const selectedOptions = fieldValue ? fieldValue.responseOptions : responseData[index]?.responseOptions;
                    const selectedCount = selectedOptions?.length || 0;
                    const isChecked = isCheckboxChecked(selectedOptions, opt.id);
                    const shouldDisable = formStatus === COMPLETED_STATUS || disableField || 
                      shouldDisableOption(item, selectedCount, isChecked);
                    
                    return (
                      <div className="form-check" key={opt.id}>
                        <input className={`form-check-input ${!isChecked && checkValidationError(item.id) ? 'border-danger' : ''}`}
                          type="checkbox"
                          disabled={shouldDisable}
                          name="radopt"
                          id={opt.id}
                          value={opt.id}
                          checked={isChecked}
                          onChange={submitRequestConstructor(index, item, false, true)} />
                        <label className="form-check-label" htmlFor={opt.id} >
                          {opt.name}
                          {renderOptionHelpText(opt)}
                        </label>
                      </div>
                    );
                  })}
                  {checkValidationError(item.id) && item.optionSelectionValidation && (
                    <div className="text-danger small mt-2">
                      {item.optionSelectionValidation.validationMessage || 
                        `Please select ${getOptionValidationMessage(item.optionSelectionValidation)}`}
                    </div>
                  )}
                </div>
                }
                {item.type === 'DROP_DOWN' && <div>
                  <select className={`form-select w-auto ${checkValidationError(item.id) &&
                    (fieldValue ? fieldValue.responseOptions[0]?.id : responseData[index]?.responseOptions[0]?.id) === ''
                    ? 'border-danger'
                    : ''
                    }`}
                    disabled={formStatus === COMPLETED_STATUS || disableField}
                    value={
                      fieldValue
                        ? fieldValue.responseOptions[0]?.id
                        : responseData[index]?.responseOptions[0]?.id
                    }
                    onChange={submitRequestConstructor(index, item, false, true)}>
                    <option value={null} disabled >Select</option>
                    {item.options.length > 0 && item.options.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.name}
                      </option>
                    ))}
                  </select>
                </div>
                }
                {item.type === 'RATING' && <div>
                  <select className={`form-select w-auto ${checkValidationError(item.id) &&
                    (fieldValue ? fieldValue.responseOptions[0]?.id : responseData[index]?.responseOptions[0]?.id) === ''
                    ? 'border-danger'
                    : ''
                    }`}
                    disabled={formStatus === COMPLETED_STATUS}>
                    <option>Agricultural</option>
                    <option>manufacturing</option>
                    <option>Agricultural</option>
                  </select>
                </div>
                }
                {item.type === 'NUMERIC_VALUE' && renderNumericQuestion(item, index, disableField)}

                {item.type === 'SINGLE_TEXTBOX' && <div className='w-100'>
                  <input type="text"
                    disabled={formStatus === COMPLETED_STATUS || disableField}
                    className={`form-control ${checkValidationError(item.id) &&
                      (fieldValue ? fieldValue.textResponse : responseData[index]?.textResponse) === ''
                      ? 'border-danger'
                      : ''
                      }`}
                    maxLength={255}
                    value={fieldValue ? fieldValue.textResponse : responseData[index]?.textResponse}
                    name={item.id}
                    onChange={submitRequestConstructor(index, item)}
                  // onBlur={submitRequestConstructor(index, item, false, true)} 
                  />
                  <div className='text-end text-secondary'>  {fieldValue ? fieldValue.textResponse.length + '/255 characters remaining' : responseData[index]?.textResponse.length + '/255 characters remaining'}</div>
                </div>
                }
                {item.type === 'DATE_TIME_BOX' && <div>
                  <input type="date"
                    disabled={formStatus === COMPLETED_STATUS || disableField}
                    className={`form-control w-auto ${checkValidationError(item.id) &&
                      !(fieldValue ? fieldValue.dateResponse : responseData[index]?.dateResponse)
                      ? 'border-danger'
                      : ''
                      }`}
                    value={fieldValue ? fieldValue.dateResponse : responseData[index]?.dateResponse}
                    name={item.id}
                    onChange={submitRequestConstructor(index, item)}
                  // onBlur={submitRequestConstructor(index, item, false, true)}
                  />
                </div>
                }
                {item.type === 'DATE_RANGE' && <div>

                  <div className="row">
                    <div className="col-6 col-sm-3">
                      <input type="date"
                        disabled={formStatus === COMPLETED_STATUS || disableField}
                        className={`form-control w-auto ${checkValidationError(item.id) &&
                          !(fieldValue ? fieldValue.dateResponse : responseData[index]?.dateResponse)
                          ? 'border-danger'
                          : ''
                          }`}
                        value={fieldValue ? fieldValue.dateResponse : responseData[index]?.dateResponse}
                        max={fieldValue ? fieldValue.toDateResponse : responseData[index]?.toDateResponse}
                        name={item.id}
                        id="dateResponse"
                        onChange={submitRequestConstructor(index, item)}
                      // onBlur={submitRequestConstructor(index, item, false, true)} 
                      />
                    </div>
                    <div className="col-6 col-sm-3">
                      <input type="date"
                        disabled={formStatus === COMPLETED_STATUS || disableField}
                        className={`form-control w-auto ${checkValidationError(item.id) &&
                          !(fieldValue ? fieldValue.toDateResponse : responseData[index]?.toDateResponse)
                          ? 'border-danger'
                          : ''
                          }`}
                        value={fieldValue ? fieldValue.toDateResponse : responseData[index]?.toDateResponse}
                        name={item.id}
                        id="toDateResponse"
                        min={fieldValue ? fieldValue.dateResponse : responseData[index]?.dateResponse}
                        onChange={submitRequestConstructor(index, item)}
                      // onBlur={submitRequestConstructor(index, item, false, true)}
                      />
                    </div>
                  </div>
                </div>
                }
                {item.type === 'TEXT_BOX' && <div>
                  <textarea className={`form-control ${checkValidationError(item.id) &&
                    !(fieldValue ? fieldValue.textResponse : responseData[index]?.textResponse)
                    ? 'border-danger'
                    : ''
                    }`}
                    disabled={formStatus === COMPLETED_STATUS || disableField}
                    rows="5"
                    maxLength={5000}
                    placeholder='Paragraph'
                    value={fieldValue ? fieldValue.textResponse : responseData[index]?.textResponse}
                    name={item.id}
                    onChange={submitRequestConstructor(index, item)} >
                  </textarea>
                  <div className='text-end text-secondary'>  {fieldValue ? fieldValue.textResponse.length + '/5000 characters remaining' : responseData[index]?.textResponse.length + '/5000 characters remaining'}</div>
                </div>

                }

                {item.type === 'FILE_UPLOAD' && <div className='file-upload-section'>
                  <input type="File"
                    disabled={formStatus === COMPLETED_STATUS}
                    className={`form-control  ${checkValidationError(item.id) && !(fileSelected || (responseData[index]?.files?.length > 0))
                      ? 'border-danger'
                      : ''
                      }`}
                    onChange={(e) => {
                      handleFileSelect(index, e);
                      setFileSelected(e.target.files.length > 0);
                    }}
                    ref={fileInputRef} />

                  <div className='UploadFileNameView d-block'>
                    {responseData[index]?.files && responseData[index]?.files.length > 0 && responseData[index]?.files.map((fileDat, fileindex) => (

                      <div key={fileindex} className='d-flex align-items-center mb-2 gap-2 w-100'>
                        <div className='UploadFileNameView_box py-2 px-3 border rounded bg-light flex-grow-1'>
                          <span className='Up_fileName text-primary text-decoration-underline text-break cursor-pointer' onClick={() => handleDownloadFile(fileDat.id)} key={fileindex}>
                            {fileDat.fileName}
                          </span>
                        </div>
                        {formStatus !== COMPLETED_STATUS &&
                          <div className='d-flex gap-2 flex-shrink-0'>
                            {Utils.isOfficeDocument(fileDat.fileName) ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={`tooltip-download-${fileindex}`}>Download File</Tooltip>}
                              >
                                <span className='upload_Download p-2 cursor' onClick={() => handleDownloadFile(fileDat.id)}>
                                  <BiDownload />
                                </span>
                              </OverlayTrigger>
                            ) : (
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={`tooltip-preview-${fileindex}`}>Preview File</Tooltip>}
                              >
                                <span className='upload_Preview p-2 cursor' onClick={() => handleFilePreview({
                                  fileId: fileDat.id,
                                  fileName: fileDat.fileName,
                                  token: decodedObj?.key ? decodedObj?.key : token,
                                  submissionId: isLoggedin ? submittedData.id : '',
                                  isFormInReview: isFormInReview
                                })}>
                                  <BiShow />
                                </span>
                              </OverlayTrigger>
                            )}
                            {Utils.isImageOrPdf(fileDat.fileName) && (
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={`tooltip-ocr-${fileindex}`}>Show the extracted values</Tooltip>}
                              >
                                <span className='upload_OCR p-2 cursor' onClick={() => getOCRData({
                                  item: item,
                                  index: index,
                                  fileId: fileDat.id,
                                  token: decodedObj?.key ? decodedObj?.key : token,
                                  submissionId: isLoggedin ? submittedData.id : '',
                                  isFormInReview: isFormInReview,
                                  fileName: fileDat.fileName
                                })}>
                                  <img src={ocr_icon} alt="OCR" className='upload_OCR_icon' />
                                </span>
                              </OverlayTrigger>
                            )}
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id={`tooltip-delete-${fileindex}`}>Delete File</Tooltip>}
                            >
                              <span className='upload_Delete p-2 cursor' onClick={() => requestRemoveFile(index, fileDat.id, fileindex, fileDat.fileName)}>
                                <BiTrash />
                              </span>
                            </OverlayTrigger>
                          </div>
                        }
                      </div>
                    ))
                    }
                  </div>
                </div>
                }
                {item.type === 'SLIDER' && <div>
                  <select className='form-select w-auto'
                    disabled={formStatus === COMPLETED_STATUS}>
                    <option>Agricultural</option>
                    <option>manufacturing</option>
                    <option>Agricultural</option>
                  </select>
                </div>
                }
                {item.type === 'SEARCH_BOX' && <div>
                  <select className='form-select w-auto'
                    disabled={formStatus === COMPLETED_STATUS}>
                    <option>Agricultural</option>
                    <option>manufacturing</option>
                    <option>Agricultural</option>
                  </select>
                </div>
                }
                {item.type === 'EMAIL' && <div>
                  <select className='form-select w-auto'
                    disabled={formStatus === COMPLETED_STATUS}>
                    <option>Agricultural</option>
                    <option>manufacturing</option>
                    <option>Agricultural</option>
                  </select>
                </div>
                }
                {item.type === 'YES_NO' && <div>
                  <select className='form-select w-auto'
                    disabled={formStatus === COMPLETED_STATUS}>
                    <option>Agricultural</option>
                    <option>manufacturing</option>
                    <option>Agricultural</option>
                  </select>
                </div>
                }

                {
                  ((item.allowRemark) ||
                    (item.allowFileUpload)) &&
                  renderCommentOrFileUploadIcons(item, index)
                }

              </div>






              {getOtherField(item, index)}
              {getRemarkField(item, index)}

              {(item.remarkMandatory || item.type === 'RADIO_GRID') && renderCommentTextArea(item, index)}
              {showComment[item.id] === true && (
                renderCommentTextArea(item, index)
              )}
              {fileUploadEnabled[item.id] === true && renderFileUpload(item, index)}
              {item.fileMandatory && renderFileUpload(item, index)}
            </div>

          </div>
        </div>
      </div>
    );
  };

  const getLocationsForSectionSubmission = () => {
    const branches = [];

    sectionSubmissions?.find(s => {
      branches.push({ id: s.branch.id, name: s.branch.name });
    });
    return branches;
  };

  const hasSubmissionForTheCurrentSection = ({ currentSectionId, submissions, form }) => {
    let hasSubmission = false;
    for (let index = 0; index < submissions?.length; index++) {
      const sectionId = submissions[index]?.section?.id ?? -1;
      if (sectionId === -1) continue;

      if (sectionId === currentSectionId) {
        hasSubmission = true;
        break;
      }
      const section = form.sections?.find(s => s.id === sectionId);
      if (!section) continue;

      const matchIndex = section.subSections?.findIndex(s => s.id === currentSectionId);
      if (matchIndex === -1) continue;

      hasSubmission = true;
      break;
    }
    return hasSubmission;
  };


  const onLocationChange = (locationId) => {
    setChosenLocationInSection(locationId);
  };

  const populateAndSetActiveLocation = ({ sectionId, submissions, form }) => {
    const locs = [];
    let sectionIdToCompare = 0;
    for (let i = 0; i < submissions?.length; i++) {
      const secSubmId = submissions[i].section?.id ?? -1;
      if (secSubmId === -1) continue;

      if (secSubmId === sectionId) {
        sectionIdToCompare = secSubmId;
        break;
      }
      // It means the current rendered section is a subsection
      const section = form.sections?.find(s => s.id === secSubmId);
      if (!section) continue;

      const matchIndex = section.subSections?.findIndex(s => s.id === sectionId);
      if (matchIndex === -1) continue;

      sectionIdToCompare = secSubmId;
      break;
    }
    submissions?.find(s => {
      if (s.section.id !== sectionIdToCompare) return;

      locs.push({ id: s.branch.id, name: s.branch.name });
    });
    setLocations(locs);
    setChosenLocationInSection(locs?.length > 0 ? locs[0].id : 0);
  };

  const saveFormData = (index, responses, fetchSubmittedDataAfterSave = false) => {
    const payload = {
      responses: [responses[index]]
    };
    if (SUBMISSION_ID) {
      payload.submissionId = SUBMISSION_ID;
    }
    const key = decodedObj?.key ? decodedObj?.key : token;
    FormEditService.submitForm(key, payload, false, isLoggedin)
      .then((res) => {
        if (res.status !== 200 && res.status !== 201) return;

        SUBMISSION_ID = res.data.submissionId;
        if (!fetchSubmittedDataAfterSave) return;

        FormEditService.getSubmittedFormData(key, langId, SUBMISSION_ID)
          .then((response) => {
            setSubmittedData(response.data);
          }).catch(err => { });
      })
      .catch((error) => {
        handleFormDataSaveError(error);
      });
  };

  const handleFormDataSaveError = (error) => {
    let valErrArr = [];
    let iterateErr = error.response?.data?.validationErrors ?? [];
    for (let i = 0; i < iterateErr.length; i++) {
      valErrArr.push(iterateErr[i].fieldId);
    }
    setValidationErrors(valErrArr);
    setLoaderState({ display: false });
    if (valErrArr.length > 0) {
      toast.error("Please check for validation errors", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };


  const onSaveAndContinue = () => {
    nextButtonRef.current.disabled = true;
    saveForm(false);
  };

  const onSubmitClick = () => {
    submitButtonRef.current.disabled = true;
    saveForm(true);
  };

  const enableActionButtons = () => {
    if (nextButtonRef?.current) {
      nextButtonRef.current.disabled = false;
    }
    if (submitButtonRef?.current) {
      submitButtonRef.current.disabled = false;
    }
  };

  const submitFormDataSkippingResponseSave = () => {
    const payload = {
      responses: [],
      skipResponseSaveOnSubmit: true
    };
    if (SUBMISSION_ID) {
      payload.submissionId = SUBMISSION_ID;
    }
    const key = decodedObj?.key ? decodedObj?.key : token;
    setLoaderState({ display: true });
    FormEditService.submitForm(key, payload, true, isLoggedin)
      .then((res) => {
        if (res.status !== 200 && res.status !== 201) return;

        toast.success("Your response has been submitted successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setFormStatus(COMPLETED_STATUS);
        let redirectUrl = localStorage.getItem('redirectUrl');
        if (isLoggedin) {
          window.location.href = redirectUrl;
        } else {
          FormEditService.getSubmittedFormData(
            decodedObj?.key ? decodedObj?.key : token,
            langId,
            res.data.submissionId
          ).then((res) => {
            setSubmittedData(res.data);
            setFormSubmissionData({ status: res.data.status, formReviewRequest: res.data.formReviewRequest });
          }).catch(err => { });
        }
        setLoaderState({ display: false });
        enableActionButtons();
      })
      .catch((error) => {
        handleFormDataSaveError(error);
        enableActionButtons();
      });
  };

  const renderLanguageSelector = () => {
    return (
      <select
        className="form-select w-auto ms-auto"
        required
        onChange={(e) => {
          getFormDetails(e.target.value);
        }}>
        <option value="" disabled hidden>Select</option>
        {formdata?.languages?.map((item) => (
          <option value={item.id} key={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    );
  };

  const renderLocationSelector = () => {
    if (formdata.reSharedForm || !hasSubmForCurSection) {
      return <></>;
    }

    return (
      <div className='mx-2'>
        {/* <h6>Choose Location</h6> */}
        <select className='form-select w-auto'
          disabled={formStatus === COMPLETED_STATUS}
          value={chosenLocationInSection}
          onChange={(e) => onLocationChange(+e.target.value)}>
          <option value={null} >Select</option>
          {
            getLocationsForSectionSubmission()?.map(location => (
              <option key={location.id} value={location.id}>{location.name}</option>
            ))
          }
        </select>
      </div>
    )
  };

  const renderSectionAuditLog = () => {
    return (
      <OverlayTrigger placement="top"
        overlay={Utils.getSectionAuditLogTooltip(submittedData)}>
        <span className='AuditLog_section 2'>
          <FaClockRotateLeft />
        </span>
      </OverlayTrigger>
    );
  };

  const renderWarningModal = () => {
    return (
      <ConfirmationModal
        modalShow={showPrompt || showUnsavedWarning}
        messageText='You have unsaved changes in this section.'
        messageSubText='Your changes will be lost if you don’t save them.'
        confirmButtonText='Save and Continue'
        callbackModal={(yes, id) => {
          if (yes) {
            onSaveAndContinue(false);
            confirmNavigation();
            setDirty(false);
            setShowUnsavedWarning(false);
          } else {
            cancelNavigation();
            setShowUnsavedWarning(false);
          }
        }}
        confirmBtn="Yes"
        CancelBtn="No"
      />
    );
  }

  const renderShareIcon = () => {
    if (formdata.reSharedForm || formdata.selfAssessment) return <></>;

    return (
      <OverlayTrigger placement="top" overlay={Utils.renderTooltip('Share Section')}>
        <span className='ms-2 ShareIcon_section'><BiShareAlt className='edit-icon' onClick={() => shareSection(activeSectionData.id)} /></span>
      </OverlayTrigger>
    );
  };

  const activateSubmittedResponseView = () => {
    return formStatus === FormStatus.COMPLETED
      || formStatus === FormStatus.CORRECTION_PENDING
      || formStatus === FormStatus.PENDING_APPROVAL
      || formStatus === FormStatus.COMPLETED;
  };

  const refreshSubmittedData = () => {
    const key = decodedObj?.key ? decodedObj?.key : token;
    let req;
    if (isFormInReview) {
      req = FormService.getSubmittedDataForReview(key);
    } else {
      req = FormEditService.getSubmittedFormData(key, langId, SUBMISSION_ID);
    }
    req?.then((res) => {
      setSubmittedData(res.data);
      setFormSubmissionData({ status: res.data.status, formReviewRequest: res.data.formReviewRequest });
    }).catch(err => { });
  };

  const refreshTotalQuestionCount = (data) => {
    let countData = { count: 0 };
    data?.fields?.forEach(f => {
      if (f.hide_alt) return;

      countData.count++;
    });
    calculateTotalQuestionCount(data?.sections, countData);
    setTotalQuestionCount(countData.count);
  };

  const toggleHelpTextPopover = (id) => {
    setVisiblePopovers((prevVisiblePopovers) => ({
      ...prevVisiblePopovers,
      [id]: !prevVisiblePopovers[id],
    }));
  };

  const popoverClickRootClose = (question) => (
    <Popover id="popover-trigger-click-root-close">
      <Popover.Header>
        Help
      </Popover.Header>
      <Popover.Body className=''>
        {question.fieldHelpText && (
          <p>
            <div dangerouslySetInnerHTML={{ __html: question.fieldHelpText }} />
          </p>
        )}
      </Popover.Body>
    </Popover>
  );

  const renderCommentOrFileUploadIcons = (item, index) => {
    return (
      <>
        <div className='Doc_UploadBtn'>
          {(item.allowRemark) && (
            <> {!(item.remarkMandatory) && item.type !== 'RADIO_GRID' &&
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-comment-${index}`}>Add Comment</Tooltip>}
              >
                <div className='p-2 cursor'>
                  <BiMessageAltDetail onClick={() => handleCommentClick(item.id)} />
                </div>
              </OverlayTrigger>
            }
            </>
          )}

          {(item.allowFileUpload) && (
            <>{
              !(item.fileMandatory) &&
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-upload-${index}`}>Upload File</Tooltip>}
              >
                <div className='p-2 cursor'>
                  <BiUpload onClick={() => handleFileUploadClick(item.id)} />
                </div>
              </OverlayTrigger>
            }            </>
          )}

        </div>
      </>
    )
  };
  const renderCommentTextArea = (item, index, fieldValue = null) => {
    return (
      <>
        <div className='comment-section'>
          {item.remarkMandatory ? (
            <label>

              Comment <span className='text-danger h5'>*</span>
            </label>
          ) : (
            <label>Comment</label>
          )}

          <textarea
            className={`form-control ${isCommentInvalid(item.id, item.remarkMandatory, responseData[index]?.remarkResponse)
              ? 'border-danger'
              : ''
              }`}
            placeholder="Add your comment"
            value={responseData[index]?.remarkResponse || ''}
            onChange={submitRequestConstructors(index, item)}
            maxLength={5000}
          ></textarea>
          <div className='text-end text-secondary'>{`${responseData[index]?.remarkResponse?.length || 0}/5000 characters remaining`}</div>
        </div>
      </>
    )
  }
  const renderFileUpload = (item, index) => {
    return (
      <div className='file-upload-section'>
        {item.fileMandatory ? (
          <label>
            Upload File (Max. size: 2 MB) : Supported file formats - jpeg, pdf, xlsx, docx <span className='text-danger h5'>*</span>
          </label>
        ) : (
          <label>Upload File (Max. size: 2 MB) : Supported file formats - jpeg, pdf, xlsx, docx</label>
        )}
        <input type='file'
          accept='.jpeg,.jpg,.pdf,.xlsx,.docx'
          className={`form-control ${isFileInvalid(item.id, item.fileMandatory, responseData[index]?.files || [])
            ? 'border-danger'
            : ''
            }`}
          onChange={(e) => {
            handleFileSelects(index, e);
          }}
          ref={fileMandatoryInputRef}
        />

        <div className='UploadFileNameView d-block'>
          {responseData[index]?.files && responseData[index]?.files.length > 0 && responseData[index]?.files.map((fileDat, fileindex) => (

            <div key={fileindex} className='d-flex align-items-center mb-2 gap-2 w-100'>
              <div className='UploadFileNameView_box py-2 px-3 border rounded bg-light flex-grow-1'>
                <span className='Up_fileName text-primary text-decoration-underline text-break cursor-pointer' onClick={() => handleDownloadFile(fileDat.id)}>
                  {fileDat.fileName}
                </span>
              </div>
              {formStatus !== COMPLETED_STATUS &&
                <div className='d-flex gap-2 flex-shrink-0'>
                  {Utils.isOfficeDocument(fileDat.fileName) ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-download-${fileindex}`}>Download File</Tooltip>}
                    >
                      <span className='upload_Download cursor-pointer text-primary p-1' onClick={() => handleDownloadFile(fileDat.id)}>
                        <BiDownload />
                      </span>
                    </OverlayTrigger>
                  ) : (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-preview-${fileindex}`}>Preview File</Tooltip>}
                    >
                      <span className='upload_Preview cursor-pointer text-primary p-1' onClick={() => handleFilePreview({
                        fileId: fileDat.id,
                        fileName: fileDat.fileName,
                        token: decodedObj?.key ? decodedObj?.key : token,
                        submissionId: isLoggedin ? submittedData.id : '',
                        isFormInReview: isFormInReview
                      })}>
                        <BiShow />
                      </span>
                    </OverlayTrigger>
                  )}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-ocr-${fileindex}`}>Show the extracted values</Tooltip>}
                  >
                    <span className='upload_OCR cursor-pointer text-info p-1' onClick={() => getOCRData({
                      item: item,
                      index: index,
                      fileId: fileDat.id,
                      token: decodedObj?.key ? decodedObj?.key : token,
                      submissionId: isLoggedin ? submittedData.id : '',
                      isFormInReview: isFormInReview,
                      fileName: fileDat.fileName
                    })}>
                      <img src={ocr_icon} alt="OCR" className='upload_OCR_icon' />
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-delete-${fileindex}`}>Delete File</Tooltip>}
                  >
                    <span className='upload_Delete cursor-pointer text-primary p-1' onClick={() => requestRemoveFile(index, fileDat.id, fileindex, fileDat.fileName)}>
                      <BiTrash />
                    </span>
                  </OverlayTrigger>
                </div>
              }
            </div>
          ))
          }
        </div>
      </div >

    );
  };

  const handleCommentClick = (itemId) => {
    const d = JSON.parse(JSON.stringify(showComment));
    d[itemId] = d[itemId] !== null ? !d[itemId] : true
    setShowComment(d);
  };
  const handleFileUploadClick = (itemId) => {
    const e = JSON.parse(JSON.stringify(fileUploadEnabled));
    e[itemId] = e[itemId] !== null ? !e[itemId] : true
    setFileUploadEnabled(e);
  };




  const scrollToSection = (sectionId) => {
    setTimeout(() => {
      const el = document.getElementById(`section-${sectionId}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  const scrollToField = (fieldId) => {
    setTimeout(() => {
      const el = document.querySelector(`[data-field-id="${fieldId}"]`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
  };

  const renderSections = (sections, sectionIndex = '') => {
    return sections?.map((section, index) => {
      if (section.hide_alt) return null;

      const isTopLevel = !section?.parentSection;
      const sectionCard = (
        <div id={`section-${section.id}`}
          key={`section-${section.id}`}
          className={`builder-section-card ${isTopLevel ? '' : 'builder-section-card--subsection'}`}
          style={{ scrollMarginTop: '90px' }}>
          <div className='builder-section-card__header'>
            <span className='builder-section-card__title'>
              {isTopLevel ? `${index + 1}. ` : `${sectionIndex}.${index + 1}. `}
              {section.title}
            </span>
            {renderShareIcon()}
            {
              showShareModal &&
              <ShareFormModal data={section}
                type="section"
                modalShow={showShareModal}
                callbackModal={callbackShareModal} />
            }
            {section.description &&
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-${section.id}`} className="custom-tooltip"><span style={{ textAlign: 'left', display: 'block' }}>{section.description}</span></Tooltip>}
              >
                <span className="builder-section-card__count">
                  <BsInfoCircle />
                </span>
              </OverlayTrigger>
            }
          </div>
          <div className='builder-section-card__body'>
            <div className='builder-field-list'>
              {
                section.fields.map((item, fIndex) => (
                  !item.hide_alt &&
                  <div className='builder-question-card' data-field-id={item.id} key={`question-card-${item.id}`}>
                    {renderQuestion(item, fIndex, undefined, undefined, getVisibleQuestionNumber(section.fields, fIndex))}
                  </div>
                ))
              }
            </div>
            {
              section?.subSections?.length > 0 &&
              <div className='builder-document__subsections'>
                {renderSections(section?.subSections, `${index + 1}`)}
              </div>
            }
          </div>
        </div>
      );

      return isTopLevel
        ? <div className='builder-document__section-block' key={`section-block-${section.id}`}>{sectionCard}</div>
        : sectionCard;
    })
  }


  const navigateFormView = () => {
    setIsSinglePageView(!isSinglePageView);
  };

  const renderNumericQuestion = (item, index, disableField) => {
    const numReponse = responseData[index]?.numericResponse ?? '';
    const uomReponse = responseData[index]?.uom;
    const isEmptyNumResponse = numReponse === '';
    const isEmptyUOMResponse = uomReponse === '';
    return (
      <>
        <NumericAnswerField
          id={item.id}
          disabled={formStatus === COMPLETED_STATUS || disableField}
          hasNumValidationError={checkValidationError(item.id) && isEmptyNumResponse}
          hasUOMValidationError={checkValidationError(item.id) && isEmptyUOMResponse}
          uomRequired={item.uomRequired}
          fieldValue={numReponse}
          unitsOfMeasure={unitsOfMeasure}
          defaultUOM={uomReponse}
          relevantUoms={item.relevantUoms}
          historicalDataSupported={formdata.historicalDataSupported && item.historicalDataSupported}
          historicalDataYears={formdata.historicalDataYears ?? []}
          historicalResponse={histResponseData}
          currentPeriod={formdata?.assessment?.period ? formdata?.assessment.period.split('-')[0] : ''}
          onAnswerChange={(e) => submitRequestConstructor(index, item)(e)}
          onUOMChange={(e) => submitRequestConstructor(index, item, true)(e)}
          onHistoricalAnswerChange={(d) => onHistResponseChange(d.value, d.year, item)}
          onHistoricalUOMChange={(d) => onHistResponseChange(d.value, d.year, item, true)} />
        {
          item.extDependency === ExternalDependencyType.EMISSION_CALCULATOR &&
          <OverlayTrigger
            key={index}
            placement="top"
            overlay={
              <Tooltip id={`tooltip-${index}`}>
                EmissionCalculator
              </Tooltip>
            }
          >
            <Button variant="outline-primary" className='Btn_Calculator  ms-2'
              onClick={() => setExtDepLinkData({
                dependency: item.extDependency,
                index: index,
                config: item.extConfig
              })}><BsCalculator /></Button>
          </OverlayTrigger>
        }
      </>
    );
  };

  const onHistResponseChange = (value, year, item, isUnit = false) => {
    const responseData = JSON.parse(JSON.stringify(histResponseData));
    const index = responseData[year]?.responses?.findIndex(r => r.formField?.id === item.id);
    if (item.type === QuestionType.NUMERIC_VALUE) {
      if (isUnit) {
        responseData[year].responses[index]['uom'] = value;
      } else {
        responseData[year].responses[index]['numericResponse'] = +value;
      }
    }
    setHistResponseData(responseData);
    setDirty(true);
  };

  return (
    <div className="FormMainBody" data-testid="FormSubmit">
      <FormHeader key="previewFormKey"
        header={formdata.name}
        showWizard={false}
        totalQuestionCount={totalQuestionCount}
        answeredQuestionCount={answeredQuestionCount}
        formData={formdata}
        navigateFormView={navigateFormView}
        formStatus={formStatus}
        isSinglePageView={isSinglePageView} />
      <div className='FormMainBody_main'>
        {
          activateSubmittedResponseView()
            ? <SubmittedResponseView
              token={decodedObj?.key ? decodedObj?.key : token}
              form={formdata}
              submittedData={submittedData}
              isFormInReview={isFormInReview}
              unitsOfMeasure={unitsOfMeasure}
              onSubmit={() => submitFormDataSkippingResponseSave()}
              onRefreshSubmittedData={() => refreshSubmittedData()}
              isSinglePageView={isSinglePageView} />
            :
            <div className='builder-shell preview-shell submitted-response-shell'
              style={{
                '--builder-sidebar-width': sidebarOpen ? `${widths.sidebar}px` : '0px',
                '--builder-panel-width': '0px',
              }}>
              <div className='builder-shell__body'>
                {
                  sidebarOpen &&
                  <ResizablePanel
                    id="form-simple-page-sidebar"
                    width={widths.sidebar}
                    onResize={setSidebarWidth}
                    side="left">
                    <FormSubmitTreeNavigation
                      name={formdata?.name}
                      fields={formdata?.fields}
                      sections={formdata?.sections}
                      currentSectionId={activeSectionData?.id ?? 0}
                      submittedData={submittedData}
                      validationError={validationerrors}
                      onSelectRootFields={(fieldId) => setActiveSectionData({ fields: formdata?.fields, subSections: [] })}
                      onSelectSection={(sectionId) => {
                        setActiveSectionData(formdata?.sections?.find(s => s.id === sectionId) || {});
                        scrollToSection(sectionId);
                      }}
                      onSelectSubSection={(subSectionId) => scrollToSection(subSectionId)}
                      onSelectQuestion={(fieldId) => scrollToField(fieldId)}
                    />
                  </ResizablePanel>
                }
                <div className='builder-shell__canvas-wrap'>
                  <div className='builder-canvas'>
                    <div className='builder-canvas__inner'>
                      <div className='builder-canvas__form-header preview-form-header pt-4'>
                        <div className='submitted-response-meta'>
                          {formdata?.assessment?.lastSubmissionDate && <div className='Department_Namebox' >
                            <span>Expiry :</span> {moment(formdata?.assessment?.lastSubmissionDate, 'YYYY-MM-DD').format("D MMMM, YYYY")}
                          </div>}
                          {Utils.getBranchOrGroupDetailsToRender(formdata)}
                          {renderLocationSelector()}
                          {renderLanguageSelector()}
                        </div>
                        {
                          formdata.formType === 'SURVEY'
                            ?
                            <div className='text-center pb-3 text-white'>
                              <h6>We value your feedback!</h6>
                              <p>Please take a few minutes to complete this survey. Click <BsInfoCircle className="d-inline-block align-middle" style={{ marginBottom: '0.15em' }} /> on item 1 to understand the purpose of this survey.</p>
                            </div>
                            :
                            <>
                              <h1>{formdata.name}</h1>
                              {formdata.description && <p className='builder-text-secondary' style={{ whiteSpace: 'pre-line' }}>{formdata.description}</p>}
                              {renderShareIcon()}
                              {
                                showShareModal &&
                                <ShareFormModal data={formdata?.fields}
                                  type="section"
                                  modalShow={showShareModal}
                                  callbackModal={callbackShareModal} />
                              }
                            </>
                        }
                      </div>
                      <div className='builder-document'>
                        {(activeSectionData.description || formdata?.fields) &&
                          <div className='builder-section-card builder-section-card--root'>
                            <div className='builder-section-card__header'>
                              <span className='builder-section-card__title'>Questions</span>
                              <span className='builder-section-card__count'>{formdata?.fields?.length ?? 0}</span>
                            </div>
                            {activeSectionData.description &&
                              <div className='px-4 pt-2'>
                                <p className='preview-section-desc'>{activeSectionData.description}</p>
                              </div>
                            }
                            {formdata?.fields &&
                              <div className='builder-section-card__body'>
                                <div className='builder-field-list'>
                                  {
                                    formdata?.fields?.map((item, index) => (
                                      !item.hide_alt &&
                                      <div className='builder-question-card' data-field-id={item.id} key={`question-card-${item.id}`}>
                                        {renderQuestion(item, index, undefined, undefined, getVisibleQuestionNumber(formdata.fields, index))}
                                      </div>
                                    ))
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                        {
                          formdata?.sections?.length > 0 &&
                          renderSections(formdata?.sections)
                        }
                      </div>
                      {
                        formStatus !== '' && formStatus !== FormStatus.COMPLETED &&
                        <div className='PS_Qus_Card_footer p-3 text-center'>
                          <button className='btn btn-primary px-4 sbmBtn m-2'
                            ref={nextButtonRef}
                            onClick={() => onSaveAndContinue(true)}>Save as Draft</button>
                          <button className='btn btn-primary px-4 sbmBtn'
                            ref={submitButtonRef}
                            onClick={() => setShowSubmitModals({ ...showSubmitModals, submitConfirmationModal: true })}>Submit</button>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <FormFooter />
            </div>
        }
      </div>
      {(showPrompt || showUnsavedWarning) && renderWarningModal()}
      {renderOCRModal()}
      <FilePreview
        show={showFilePreviewModal}
        onHide={handleFilePreviewClose}
        fileData={previewFileData}
        fileContent={previewFileContent}
        fileType={previewFileType}
        onDownload={() => {
          if (previewFileData) {
            const link = document.createElement('a');
            link.href = `data:${previewFileData.contentType};base64,${previewFileData.content}`;
            link.download = previewFileData.fileName;
            link.click();
          }
        }}
      />
      <ConfirmDialog
        title="Delete File"
        open={confirmDeleteFile.show}
        setOpen={(show) => setConfirmDeleteFile(prev => ({ ...prev, show }))}
        onConfirm={() => handleRemoveFile(confirmDeleteFile.itemIndex, confirmDeleteFile.fileId, confirmDeleteFile.fileIndex)}
      >
        <div className="text-center">Are you sure you want to delete <strong>{confirmDeleteFile.fileName}</strong>?</div>
      </ConfirmDialog>
      {
        extDepLinkData?.index >= 0 &&
        <ExternalDependencyPopup type={extDepLinkData.dependency}
          config={extDepLinkData.config}
          reportingPeriod={formdata.assessment?.period}
          companyId={formdata.company?.id}
          branchId={formdata.branch?.id}
          callbackModal={(display, val) => {
            if (display) {
              const req = JSON.parse(JSON.stringify(responseData));
              req[extDepLinkData.index]['numericResponse'] = val;
              setResponseData(req);
            }
            setExtDepLinkData('');
          }} />
      }
      {
        showSubmitModals.submitConfirmationModal &&
        <ConfirmationModal
          modalShow={showSubmitModals.submitConfirmationModal}
          messageText={`You have completed ${Math.round((answeredQuestionCount / totalQuestionCount) * 100)}% of the survey.`}
          messageSubText={"Click 'Confirm' to proceed with the submission or 'Cancel' to continue with the survey. Once submitted, you will not be able to make any further changes to the responses."}
          confirmButtonText='Confirm'
          callbackModal={(yes) => {
            if (yes) {
              onSubmitClick();
            } else {
              setShowSubmitModals({ submitConfirmationModal: false, navigateToResponseModal: false });
            }
          }}
          confirmBtn="Yes"
          CancelBtn="No"
        />
      }
      {
        showSubmitModals.navigateToResponseModal &&
        <ConfirmationModal
          modalShow={showSubmitModals.navigateToResponseModal}
          messageText={'Your feedback has been successfully submitted. We truly appreciate your time and input in helping us prioritize what matters most. Your responses will guide our next steps in creating a positive impact.'}
          messageSubText={'If you have any additional thoughts, feel free to reach out to us!'}
          confirmButtonText='View My Response'
          cancelButtonText="No, Thanks"
          type='FORM_SUBMIT'
          callbackModal={(yes) => {
            if (yes) {
              setFormStatus(COMPLETED_STATUS);
              setShowSubmitModals({ submitConfirmationModal: false, navigateToResponseModal: false });
            } else {
              setShowSubmitModals({ submitConfirmationModal: false, navigateToResponseModal: false });
            }
          }}
          confirmBtn="Yes"
          CancelBtn="No"
        />
      }
    </div>
  )
};

export default FormSimplePageView;